import React, { Component } from "react";
import styles from "./Datenschutz.module.css"; 
import {Helmet} from "react-helmet";

class Datenschutz extends Component {
  state = {};
  render() {
    return (
      <div className={styles.container}>
                                    <Helmet> 
          <title>Privacy Policy | Kooikerhondje</title>
          <meta
            name="description"
            content="Kooikerhondje de la bande de rigolos"
          />
          <meta
            name="keywords"
            content="Kooikerhondje, Kooiker, breeding, puppies, France"
          />
          <link rel="canonical" href="https://kooiker-fr.com/datenschutz" />
          </Helmet>
        <div className={styles.mainHeader}>
          <h1 className="adsimple-111742326">Datenschutzerklärung</h1>
        </div>
        <div className={styles.content}>

          <br /><h2>Inhaltsverzeichnis</h2>
          <ul>
            <li>
              <a href="#einleitung-ueberblick">Einleitung und Überblick</a>
            </li>
            <li>
              <a href="#anwendungsbereich">Anwendungsbereich</a>
            </li>
            <li>
              <a href="#rechtsgrundlagen">Rechtsgrundlagen</a>
            </li>
            <li>
              <a href="#speicherdauer">Speicherdauer</a>
            </li>
            <li>
              <a href="#rechte-dsgvo">Rechte laut Datenschutzgrundverordnung</a>
            </li>
            <li>
              <a href="#datenuebertragung-drittlaender">
                Datenübertragung in Drittländer
              </a>
            </li>
            <li>
              <a href="#sicherheit-datenverarbeitung">
                Sicherheit der Datenverarbeitung
              </a>
            </li>
            <li>
              <a href="#webhosting">Webhosting</a>
            </li>
            <li>
              <a href="#cookies">Cookies</a>
            </li>
            <li>
              <a href="#web-analytics">Web Analytics</a>
            </li>
            <li>
              <a href="#google-analytics-datenschutzerklaerung">
                Google Analytics Datenschutzerklärung
              </a>
            </li>
            <li>
              <a href="#adsimple-cookie-manager-datenschutzerklaerung">
                AdSimple Cookie Manager Datenschutzerklärung
              </a>
            </li>
            <li>
              <a href="#facebook-datenschutzerklaerung">
                Facebook Datenschutzerklärung
              </a>
            </li>
            <li>
              <a href="#twitter-datenschutzerklaerung">
                Twitter Datenschutzerklärung
              </a>
            </li>
            <li>
              <a href="#google-maps-datenschutzerklaerung">
                Google Maps Datenschutzerklärung
              </a>
            </li>
            <li>
              <a href="#google-fonts-lokal-datenschutzerklaerung">
                Google Fonts Lokal Datenschutzerklärung
              </a>
            </li>
            <li>
              <a href="#google-fonts-datenschutzerklaerung">
                Google Fonts Datenschutzerklärung
              </a>
            </li>
            <li>
              <a href="#font-awesome-datenschutzerklaerung">
                Font Awesome Datenschutzerklärung
              </a>
            </li>
            <li>
              <a href="#bootstrapcdn-datenschutzerklaerung">
                BootstrapCDN Datenschutzerklärung
              </a>
            </li>
          </ul>
          <br /><h2 id="einleitung-ueberblick" classNameName="adsimple-111742326">
            Einleitung und Überblick
          </h2>
          <p>
            Wir haben diese Datenschutzerklärung (Fassung 19.05.2021-111742326)
            verfasst, um Ihnen gemäß der Vorgaben der{" "}
            <a
              className="adsimple-111742326"
              href="https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679&tid=111742326"
              target="_blank"
              rel="noreferrer"
            >
              Datenschutz-Grundverordnung (EU) 2016/679
            </a>{" "}
            und anwendbaren nationalen Gesetzen zu erklären, welche
            personenbezogenen Daten (kurz Daten) wir als Verantwortliche – und
            die von uns beauftragten Auftragsverarbeiter (z. B. Provider) –
            verarbeiten, zukünftig verarbeiten werden und welche rechtmäßigen
            Möglichkeiten Sie haben. Die verwendeten Begriffe sind
            geschlechtsneutral zu verstehen.
            <br />
            <strong classNameName="adsimple-111742326">Kurz gesagt:</strong> Wir
            informieren Sie umfassend über Daten, die wir über Sie verarbeiten.
          </p>
          <p>
            Datenschutzerklärungen klingen für gewöhnlich sehr technisch und
            verwenden juristische Fachbegriffe. Diese Datenschutzerklärung soll
            Ihnen hingegen die wichtigsten Dinge so einfach und transparent wie
            möglich beschreiben. Soweit es der Transparenz förderlich ist,
            werden technische{" "}
            <strong classNameName="adsimple-111742326">
              Begriffe leserfreundlich erklärt
            </strong>
            , <strong classNameName="adsimple-111742326">Links</strong> zu
            weiterführenden Informationen geboten und{" "}
            <strong classNameName="adsimple-111742326">Grafiken</strong> zum
            Einsatz gebracht. Wir informieren damit in klarer und einfacher
            Sprache, dass wir im Rahmen unserer Geschäftstätigkeiten nur dann
            personenbezogene Daten verarbeiten, wenn eine entsprechende
            gesetzliche Grundlage gegeben ist. Das ist sicher nicht möglich,
            wenn man möglichst knappe, unklare und juristisch-technische
            Erklärungen abgibt, so wie sie im Internet oft Standard sind, wenn
            es um Datenschutz geht. Ich hoffe Sie finden die folgenden
            Erläuterungen interessant und informativ und vielleicht ist die eine
            oder andere Information dabei, die Sie noch nicht kannten.
            <br />
            Wenn trotzdem Fragen bleiben, möchten wir Sie bitten, sich an die
            unten bzw. im Impressum genannte verantwortliche Stelle zu wenden,
            den vorhandenen Links zu folgen und sich weitere Informationen auf
            Drittseiten anzusehen. Unsere Kontaktdaten finden Sie
            selbstverständlich auch im Impressum.
          </p>
          <br /><h2 id="anwendungsbereich" classNameName="adsimple-111742326">
            Anwendungsbereich
          </h2>
          <p>
            Diese Datenschutzerklärung gilt für alle von uns im Unternehmen
            verarbeiteten personenbezogenen Daten und für alle personenbezogenen
            Daten, die von uns beauftragte Firmen (Auftragsverarbeiter)
            verarbeiten. Mit personenbezogenen Daten meinen wir Informationen
            wie zum Beispiel Name, E-Mail-Adresse und postalische Anschrift
            einer Person. Die Verarbeitung personenbezogener Daten sorgt dafür,
            dass wir unsere Dienstleistungen und Produkte anbieten und abrechnen
            können, sei es online oder offline. Der Anwendungsbereich dieser
            Datenschutzerklärung umfasst:
          </p>
          <ul classNameName="adsimple-111742326">
            <li classNameName="adsimple-111742326">
              alle Onlineauftritte (Websites, Onlineshops), die wir betreiben
            </li>
            <li classNameName="adsimple-111742326">
              Social Media Auftritte und E-Mail-Kommunikation
            </li>
            <li classNameName="adsimple-111742326">
              mobile Apps für Smartphones und andere Geräte
            </li>
          </ul>
          <p>
            <strong classNameName="adsimple-111742326">Kurz gesagt:</strong> Die
            Datenschutzerklärung gilt für alle Bereiche, in denen
            personenbezogene Daten im Unternehmen strukturiert verarbeitet
            werden.
          </p>
          <br /><h2 id="rechtsgrundlagen" classNameName="adsimple-111742326">
            Rechtsgrundlagen
          </h2>
          <p>
            In der folgenden Datenschutzerklärung geben wir Ihnen transparente
            Informationen zu den rechtlichen Grundsätzen und Vorschriften, also
            den Rechtsgrundlagen der Datenschutz-Grundverordnung, die uns
            ermöglichen, personenbezogene Daten zu verarbeiten.
            <br />
            Was das EU-Recht betrifft, beziehen wir uns auf die VERORDNUNG (EU)
            2016/679 DES EUROPÄISCHEN PARLAMENTS UND DES RATES vom 27. April
            2016. Diese Datenschutz-Grundverordnung der EU können Sie
            selbstverständlich online auf EUR-Lex, dem Zugang zum EU-Recht,
            unter{" "}
            <a
              classNameName="adsimple-111742326"
              href="https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679&tid=111742326"
              target="_blank"
              rel="noreferrer"
            >
              https://eur-lex.europa.eu/legal-content/DE/TXT/?uri=celex%3A32016R0679
            </a>{" "}
            nachlesen.
          </p>
          <p>
            Wir verarbeiten Ihre Daten nur, wenn mindestens eine der folgenden
            Bedingungen zutrifft:
          </p>
          <ol>
            <li classNameName="adsimple-111742326">
              <strong classNameName="adsimple-111742326">Einwilligung</strong>{" "}
              (Artikel 6 Absatz 1 lit. a DSGVO): Sie haben uns Ihre Einwilligung
              gegeben, Daten zu einem bestimmten Zweck zu verarbeiten. Ein
              Beispiel wäre die Speicherung Ihrer eingegebenen Daten eines
              Kontaktformulars.
            </li>
            <li classNameName="adsimple-111742326">
              <strong classNameName="adsimple-111742326">Vertrag</strong>{" "}
              (Artikel 6 Absatz 1 lit. b DSGVO): Um einen Vertrag oder
              vorvertragliche Verpflichtungen mit Ihnen zu erfüllen, verarbeiten
              wir Ihre Daten. Wenn wir zum Beispiel einen Kaufvertrag mit Ihnen
              abschließen, benötigen wir vorab personenbezogene Informationen.
            </li>
            <li classNameName="adsimple-111742326">
              <strong classNameName="adsimple-111742326">
                Rechtliche Verpflichtung
              </strong>{" "}
              (Artikel 6 Absatz 1 lit. c DSGVO): Wenn wir einer rechtlichen
              Verpflichtung unterliegen, verarbeiten wir Ihre Daten. Zum
              Beispiel sind wir gesetzlich verpflichtet Rechnungen für die
              Buchhaltung aufzuheben. Diese enthalten in der Regel
              personenbezogene Daten.
            </li>
            <li classNameName="adsimple-111742326">
              <strong classNameName="adsimple-111742326">
                Berechtigte Interessen
              </strong>{" "}
              (Artikel 6 Absatz 1 lit. f DSGVO): Im Falle berechtigter
              Interessen, die Ihre Grundrechte nicht einschränken, behalten wir
              uns die Verarbeitung personenbezogener Daten vor. Wir müssen zum
              Beispiel gewisse Daten verarbeiten, um unsere Website sicher und
              wirtschaftlich effizient betreiben zu können. Diese Verarbeitung
              ist somit ein berechtigtes Interesse.
            </li>
          </ol>
          <p>
            Weitere Bedingungen wie die Wahrnehmung von Aufnahmen im
            öffentlichen Interesse und Ausübung öffentlicher Gewalt sowie dem
            Schutz lebenswichtiger Interessen treten bei uns in der Regel nicht
            auf. Soweit eine solche Rechtsgrundlage doch einschlägig sein
            sollte, wird diese an der entsprechenden Stelle ausgewiesen.
          </p>
          <p>
            Zusätzlich zu der EU-Verordnung, gelten auch noch nationale Gesetze:
          </p>
          <ul classNameName="adsimple-111742326">
            <li classNameName="adsimple-111742326">
              In <strong classNameName="adsimple-111742326">Österreich</strong>{" "}
              ist dies das Bundesgesetz zum Schutz natürlicher Personen bei der
              Verarbeitung personenbezogener Daten (
              <strong classNameName="adsimple-111742326">
                Datenschutzgesetz
              </strong>
              ), kurz <strong className="adsimple-111742326">DSG</strong>.
            </li>
            <li className="adsimple-111742326">
              In <strong className="adsimple-111742326">Deutschland</strong>{" "}
              gilt das{" "}
              <strong className="adsimple-111742326">
                Bundesdatenschutzgesetz
              </strong>
              , kurz<strong className="adsimple-111742326"> BDSG</strong>.
            </li>
          </ul>
          <p>
            Sofern weitere regionale oder nationale Gesetze zur Anwendung
            kommen, informieren wir Sie in den folgenden Abschnitten darüber.
          </p>
          <br /><h2 id="speicherdauer" className="adsimple-111742326">
            Speicherdauer
          </h2>
          <p>
            Dass wir personenbezogene Daten nur so lange speichern, wie es für
            die Bereitstellung unserer Dienstleistungen und Produkte unbedingt
            notwendig ist, gilt als generelles Kriterium bei uns. Wenn es zum
            Beispiel im Fall von Buchhaltung gesetzlich vorgeschrieben ist, kann
            diese Speicherdauer auch überschritten werden. Das bedeutet, dass
            wir personenbezogene Daten löschen, sobald der Grund für die
            Datenverarbeitung nicht mehr vorhanden ist. Sollten Sie die Löschung
            Ihrer Daten wünschen oder die Einwilligung zur Datenverarbeitung
            widerrufen, werden die Daten so rasch wie möglich und soweit keine
            Pflicht zur Speicherung besteht, gelöscht.
          </p>
          <p>
            Über die konkrete Dauer der jeweiligen Datenverarbeitung informieren
            wir Sie weiter unten, sofern wir weitere Informationen dazu haben.
          </p>
          <br /><h2 id="rechte-dsgvo" className="adsimple-111742326">
            Rechte laut Datenschutzgrundverordnung
          </h2>
          <p>
            Laut Artikel 13 DSGVO stehen Ihnen die folgenden Rechte zu, damit es
            zu einer fairen und transparenten Verarbeitung von Daten kommt:
          </p>
          <ul className="adsimple-111742326">
            <li className="adsimple-111742326">
              Sie haben laut Artikel 15 DSGVO ein Auskunftsrecht darüber, ob wir
              Daten von Ihnen verarbeiten. Sollte das zutreffen, haben Sie Recht
              darauf eine Kopie der Daten zu erhalten und die folgenden
              Informationen zu erfahren:
              <ul className="adsimple-111742326">
                <li className="adsimple-111742326">
                  zu welchem Zweck wir die Verarbeitung durchführen;
                </li>
                <li className="adsimple-111742326">
                  die Kategorien, also die Arten von Daten, die verarbeitet
                  werden;
                </li>
                <li className="adsimple-111742326">
                  wer diese Daten erhält und wenn die Daten an Drittländer
                  übermittelt werden, wie die Sicherheit garantiert werden kann;
                </li>
                <li className="adsimple-111742326">
                  wie lange die Daten gespeichert werden;
                </li>
                <li className="adsimple-111742326">
                  das Bestehen des Rechts auf Berichtigung, Löschung oder
                  Einschränkung der Verarbeitung und dem Widerspruchsrecht gegen
                  die Verarbeitung;
                </li>
                <li className="adsimple-111742326">
                  dass Sie sich bei einer Aufsichtsbehörde beschweren können
                  (Links zu diesen Behörden finden Sie weiter unten);
                </li>
                <li className="adsimple-111742326">
                  die Herkunft der Daten, wenn wir sie nicht bei Ihnen erhoben
                  haben;
                </li>
                <li className="adsimple-111742326">
                  ob Profiling durchgeführt wird, ob also Daten automatisch
                  ausgewertet werden, um zu einem persönlichen Profil von Ihnen
                  zu gelangen.
                </li>
              </ul>
            </li>
            <li className="adsimple-111742326">
              Sie haben laut Artikel 16 DSGVO ein Recht auf Berichtigung der
              Daten, was bedeutet, dass wir Daten richtig stellen müssen, falls
              Sie Fehler finden.
            </li>
            <li className="adsimple-111742326">
              Sie haben laut Artikel 17 DSGVO das Recht auf Löschung („Recht auf
              Vergessenwerden“), was konkret bedeutet, dass Sie die Löschung
              Ihrer Daten verlangen dürfen.
            </li>
            <li className="adsimple-111742326">
              Sie haben laut Artikel 18 DSGVO das Recht auf Einschränkung der
              Verarbeitung, was bedeutet, dass wir die Daten nur mehr speichern
              dürfen aber nicht weiter verwenden.
            </li>
            <li className="adsimple-111742326">
              Sie haben laut Artikel 19 DSGVO das Recht auf
              Datenübertragbarkeit, was bedeutet, dass wir Ihnen auf Anfrage
              Ihre Daten in einem gängigen Format zur Verfügung stellen.
            </li>
            <li className="adsimple-111742326">
              Sie haben laut Artikel 21 DSGVO ein Widerspruchsrecht, welches
              nach Durchsetzung eine Änderung der Verarbeitung mit sich bringt.
              <ul className="adsimple-111742326">
                <li className="adsimple-111742326">
                  Wenn die Verarbeitung Ihrer Daten auf Artikel 6 Abs. 1 lit. e
                  (öffentliches Interesse, Ausübung öffentlicher Gewalt) oder
                  Artikel 6 Abs. 1 lit. f (berechtigtes Interesse) basiert,
                  können Sie gegen die Verarbeitung Widerspruch einlegen. Wir
                  prüfen danach so rasch wie möglich, ob wir diesem Widerspruch
                  rechtlich nachkommen können.
                </li>
                <li className="adsimple-111742326">
                  Werden Daten verwendet, um Direktwerbung zu betreiben, können
                  Sie jederzeit gegen diese Art der Datenverarbeitung
                  widersprechen. Wir dürfen Ihre Daten danach nicht mehr für
                  Direktmarketing verwenden.
                </li>
                <li className="adsimple-111742326">
                  Werden Daten verwendet, um Profiling zu betreiben, können Sie
                  jederzeit gegen diese Art der Datenverarbeitung widersprechen.
                  Wir dürfen Ihre Daten danach nicht mehr für Profiling
                  verwenden.
                </li>
              </ul>
            </li>
            <li className="adsimple-111742326">
              Sie haben laut Artikel 22 DSGVO unter Umständen das Recht, nicht
              einer ausschließlich auf einer automatisierten Verarbeitung (zum
              Beispiel Profiling) beruhenden Entscheidung unterworfen zu werden.
            </li>
          </ul>
          <p>
            Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das
            Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche
            in sonst einer Weise verletzt worden sind, können Sie sich bei der
            Aufsichtsbehörde beschweren. Diese ist für Österreich die
            Datenschutzbehörde, deren Website Sie unter{" "}
            <a
              className="adsimple-111742326"
              href="https://www.dsb.gv.at/?tid=111742326"
              target="_blank"
              rel="noreferrer"
            >
              https://www.dsb.gv.at/
            </a>{" "}
            finden und für Deutschland können Sie sich an die{" "}
            <a
              className="adsimple-111742326"
              href="https://www.bfdi.bund.de"
              target="_blank"
              rel="noreferrer"
            >
              Bundesbeauftragte für den Datenschutz und die Informationsfreiheit
              (BfDI)
            </a>{" "}
            wenden.
          </p>
          <p>
            <strong className="adsimple-111742326">Kurz gesagt:</strong> Sie
            haben Rechte – zögern Sie nicht, die oben gelistete verantwortliche
            Stelle bei uns zu kontaktieren!
          </p>
          <br /><h2
            id="datenuebertragung-drittlaender"
            className="adsimple-111742326"
          >
            Datenübertragung in Drittländer
          </h2>
          <p>
            Wir übertragen oder verarbeiten Daten nur dann in Länder außerhalb
            der EU (Drittländer), wenn Sie dieser Verarbeitung zustimmen, dies
            gesetzlich vorgeschrieben ist oder vertraglich notwendig und in
            jedem Fall nur soweit dies generell erlaubt ist. Ihre Zustimmung ist
            in den meisten Fällen der wichtigste Grund, dass wir Daten in
            Drittländern verarbeiten lassen. Die Verarbeitung personenbezogener
            Daten in Drittländern wie den USA, wo viele Softwarehersteller
            Dienstleistungen anbieten und Ihre Serverstandorte haben, kann
            bedeuten, dass personenbezogene Daten auf unerwartete Weise
            verarbeitet und gespeichert werden. Nach Möglichkeit versuchen wir
            Serverstandorte innerhalb der EU zu nutzen, sofern das angeboten
            wird.
          </p>
          <p>
            Wir informieren Sie an den passenden Stellen dieser
            Datenschutzerklärung genauer über Datenübertragung in Drittländer,
            sofern diese zutrifft.
          </p>
          <br /><h2 id="sicherheit-datenverarbeitung" className="adsimple-111742326">
            Sicherheit der Datenverarbeitung
          </h2>
          <p>
            Um personenbezogene Daten zu schützen, haben wir sowohl technische
            als auch organisatorische Maßnahmen umgesetzt. Wo es uns möglich
            ist, verschlüsseln oder pseudonymisieren wir personenbezogene Daten.
            Dadurch machen wir es im Rahmen unserer Möglichkeiten so schwer wie
            möglich, dass Dritte aus unseren Daten auf persönliche Informationen
            schließen können.
          </p>
          <p>
            Art. 25 DSGVO spricht hier von “Datenschutz durch Technikgestaltung
            und durch datenschutzfreundliche Voreinstellungen” und meint damit,
            dass man sowohl bei Software (z. B. Formularen) also auch Hardware
            (z. B. Zugang zum Serverraum) immer an Sicherheit denkt und
            entsprechende Maßnahmen setzt. Im Folgenden gehen wir, falls
            erforderlich, noch auf konkrete Maßnahmen ein.
          </p>
          <br /><h2 id="tls-verschluesselung-https" className="adsimple-111742326">
            TLS-Verschlüsselung mit https
          </h2>
          <p>
            TLS, Verschlüsselung und https klingen sehr technisch und sind es
            auch. Wir verwenden HTTPS (das Hypertext Transfer Protocol Secure
            steht für „sicheres Hypertext-Übertragungsprotokoll“), um Daten
            abhörsicher im Internet zu übertragen.
            <br />
            Das bedeutet, dass die komplette Übertragung aller Daten von Ihrem
            Browser zu unserem Webserver abgesichert ist – niemand kann
            “mithören”.
          </p>
          <p>
            Damit haben wir eine zusätzliche Sicherheitsschicht eingeführt und
            erfüllen Datenschutz durch Technikgestaltung{" "}
            <a
              className="adsimple-111742326"
              href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=111742326"
              target="_blank"
              rel="noreferrer"
            >
              Artikel 25 Absatz 1 DSGVO
            </a>
            ). Durch den Einsatz von TLS (Transport Layer Security), einem
            Verschlüsselungsprotokoll zur sicheren Datenübertragung im Internet,
            können wir den Schutz vertraulicher Daten sicherstellen.
            <br />
            Sie erkennen die Benutzung dieser Absicherung der Datenübertragung
            am kleinen Schlosssymbol{" "}
            <img alt={"Image2"}
              src={"https://www.adsimple.at/wp-content/uploads/2018/03/schlosssymbol-https.svg"}
              width={"17"}
              height={"18"}
            />{" "}
            links oben im Browser, links von der Internetadresse (z. B.
            beispielseite.de) und der Verwendung des Schemas https (anstatt
            http) als Teil unserer Internetadresse.
            <br />
            Wenn Sie mehr zum Thema Verschlüsselung wissen möchten, empfehlen
            wir die Google Suche nach “Hypertext Transfer Protocol Secure wiki”
            um gute Links zu weiterführenden Informationen zu erhalten.
          </p>
          <br /><h2 id="webhosting" className="adsimple-111742326">
            Webhosting
          </h2>
          <table border="1" cellpadding="15">
            <tbody>
              <tr>
                <td>
                  <strong className="adsimple-111742326">
                  <div className={styles.boxTitle}>Webhosting Zusammenfassung</div>
                  </strong>
                  <div className={styles.box}>
                  👥 Betroffene: Besucher der Website
                  <br />
                  🤝 Zweck: professionelles Hosting der Website und Absicherung
                  des Betriebs
                  <br />
                  📓 Verarbeitete Daten: IP-Adresse, Zeitpunkt des
                  Websitebesuchs, verwendeter Browser und weitere Daten. Mehr
                  Details dazu finden Sie weiter unten bzw. beim jeweils
                  eingesetzten Webhosting Provider.
                  <br />
                  📅 Speicherdauer: abhängig vom jeweiligen Provider, aber in
                  der Regel 2 Wochen
                  <br />
                  ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit.f DSGVO (Berechtigte
                  Interessen)
                  </div></td>
              </tr>
            </tbody>
          </table>
          <br /><h3 className="adsimple-111742326">Was ist Webhosting?</h3>
          <p>
            Wenn Sie heutzutage Websites besuchen, werden gewisse Informationen
            – auch personenbezogene Daten – automatisch erstellt und
            gespeichert, so auch auf dieser Website. Diese Daten sollten
            möglichst sparsam und nur mit Begründung verarbeitet werden. Mit
            Website meinen wir übrigens die Gesamtheit aller Webseiten auf einer
            Domain, d.h. alles von der Startseite (Homepage) bis hin zur aller
            letzten Unterseite (wie dieser hier). Mit Domain meinen wir zum
            Beispiel beispiel.de oder musterbeispiel.com.
          </p>
          <p>
            Wenn Sie eine Website auf einem Bildschirm ansehen möchten,
            verwenden Sie dafür ein Programm, das sich Webbrowser nennt. Sie
            kennen vermutlich einige Webbrowser beim Namen: Google Chrome,
            Microsoft Edge, Mozilla Firefox und Apple Safari.
          </p>
          <p>
            Dieser Webbrowser muss sich zu einem anderen Computer verbinden, wo
            der Code der Website gespeichert ist: dem Webserver. Der Betrieb
            eines Webservers ist eine komplizierte und aufwendige Aufgabe,
            weswegen dies in der Regel von professionellen Anbietern, den
            Providern, übernommen wird. Diese bieten Webhosting an und sorgen
            damit für eine verlässliche und fehlerfreie Speicherung der Daten
            von Websites.
          </p>
          <p>
            Bei der Verbindungsaufnahme des Browsers auf Ihrem Computer
            (Desktop, Laptop, Smartphone) und während der Datenübertragung zu
            und vom Webserver kann es zu einer Verarbeitung personenbezogener
            Daten kommen. Einerseits speichert Ihr Computer Daten, andererseits
            muss auch der Webserver Daten eine Zeit lang speichern, um einen
            ordentlichen Betrieb zu gewährleisten.
          </p>
          <p>Zur Veranschaulichung:</p>
          <p>
            <img
              src={"https://www.adsimple.at/wp-content/uploads/2018/03/browser-und-webserver.svg"}
              alt={"Browser und Webserver"}
              width={"100%"}
            />
          </p>
          <br /><h3 className="adsimple-111742326">
            Warum verarbeiten wir personenbezogene Daten?
          </h3>
          <p>Die Zwecke der Datenverarbeitung sind:</p>
          <ol>
            <li className="adsimple-111742326">
              Professionelles Hosting der Website und Absicherung des Betriebs
            </li>
            <li className="adsimple-111742326">
              Aus Gründen der Betriebssicherheit und zur Erstellung von
              Zugriffsstatistiken
            </li>
          </ol>
          <br /><h3 className="adsimple-111742326">
            Welche Daten werden verarbeitet?
          </h3>
          <p>
            Auch während Sie unsere Website jetzt gerade besuchen, speichert
            unser Webserver, das ist der Computer auf dem diese Webseite
            gespeichert ist, in der Regel automatisch Daten wie
          </p>
          <ul className="adsimple-111742326">
            <li className="adsimple-111742326">
              die komplette Internetadresse (URL) der aufgerufenen Webseite (z.
              B.
              https://www.beispielwebsite.de/beispielunterseite.html?tid=111742326)
            </li>
            <li className="adsimple-111742326">
              Browser und Browserversion (z. B. Chrome 87)
            </li>
            <li className="adsimple-111742326">
              das verwendete Betriebssystem (z. B. Windows 10)
            </li>
            <li className="adsimple-111742326">
              die Adresse (URL) der zuvor besuchten Seite (Referrer URL) (z. B.
              https://www.beispielquellsite.de/vondabinichgekommen.html/)
            </li>
            <li className="adsimple-111742326">
              den Hostnamen und die IP-Adresse des Geräts von welchem aus
              zugegriffen wird (z. B. COMPUTERNAME und 194.23.43.121)
            </li>
            <li className="adsimple-111742326">Datum und Uhrzeit</li>
            <li className="adsimple-111742326">
              in Dateien, den sogenannten Webserver-Logfiles
            </li>
          </ul>
          <br /><h3 className="adsimple-111742326">
            Wie lange werden Daten gespeichert?
          </h3>
          <p>
            In der Regel werden die oben genannten Daten zwei Wochen gespeichert
            und danach automatisch gelöscht. Wir geben diese Daten nicht weiter,
            können jedoch nicht ausschließen, dass diese Daten beim Vorliegen
            von rechtswidrigem Verhalten von Behörden eingesehen werden.
          </p>
          <p>
            <strong className="adsimple-111742326">Kurz gesagt:</strong> Ihr
            Besuch wird durch unseren Provider (Firma, die unsere Website auf
            speziellen Computern (Servern) laufen lässt), protokolliert, aber
            wir geben Ihre Daten nicht ohne Zustimmung weiter!
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Die Rechtmäßigkeit der Verarbeitung personenbezogener Daten im
            Rahmen des Webhosting ergibt sich aus Art. 6 Abs. 1 lit. f DSGVO
            (Wahrung der berechtigten Interessen), denn die Nutzung von
            professionellem Hosting bei einem Provider ist notwendig, um das
            Unternehmen im Internet sicher und nutzerfreundlich präsentieren zu
            können.
          </p>
          <br /><h2 id="cookies" className="adsimple-111742326">
            Cookies
          </h2>
          <table border="1" cellpadding="15">
            <tbody>
              <tr>
                <td>
                  <strong className="adsimple-111742326">
                  <div className={styles.boxTitle}> Cookies Zusammenfassung</div>
                  </strong>
                  <br /><div className={styles.box}>
                  👥 Betroffene: Besucher der Website
                  <br />
                  🤝 Zweck: abhängig vom jeweiligen Cookie. Mehr Details dazu
                  finden Sie weiter unten bzw. beim Hersteller der Software, der
                  das Cookie setzt.
                  <br />
                  📓 Verarbeitete Daten: Abhängig vom jeweils eingesetzten
                  Cookie. Mehr Details dazu finden Sie weiter unten bzw. beim
                  Hersteller der Software, der das Cookie setzt.
                  <br />
                  📅 Speicherdauer: abhängig vom jeweiligen Cookie, kann von
                  Stunden bis hin zu Jahren variieren
                  <br />
                  ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO
                  (Einwilligung), Art. 6 Abs. 1 lit.f DSGVO (Berechtigte
                  Interessen)
               </div> </td>
              </tr>
            </tbody>
          </table>
          <br /><h3 className="adsimple-111742326">Was sind Cookies?</h3>
          <p>
            Unsere Website verwendet HTTP-Cookies, um nutzerspezifische Daten zu
            speichern.
            <br />
            Im Folgenden erklären wir, was Cookies sind und warum Sie genutzt
            werden, damit Sie die folgende Datenschutzerklärung besser
            verstehen.
          </p>
          <p>
            Immer wenn Sie durch das Internet surfen, verwenden Sie einen
            Browser. Bekannte Browser sind beispielsweise Chrome, Safari,
            Firefox, Internet Explorer und Microsoft Edge. Die meisten Websites
            speichern kleine Text-Dateien in Ihrem Browser. Diese Dateien nennt
            man Cookies.
          </p>
          <p>
            Eines ist nicht von der Hand zu weisen: Cookies sind echt nützliche
            Helferlein. Fast alle Websites verwenden Cookies. Genauer gesprochen
            sind es HTTP-Cookies, da es auch noch andere Cookies für andere
            Anwendungsbereiche gibt. HTTP-Cookies sind kleine Dateien, die von
            unserer Website auf Ihrem Computer gespeichert werden. Diese
            Cookie-Dateien werden automatisch im Cookie-Ordner, quasi dem “Hirn”
            Ihres Browsers, untergebracht. Ein Cookie besteht aus einem Namen
            und einem Wert. Bei der Definition eines Cookies müssen zusätzlich
            ein oder mehrere Attribute angegeben werden.
          </p>
          <p>
            Cookies speichern gewisse Nutzerdaten von Ihnen, wie beispielsweise
            Sprache oder persönliche Seiteneinstellungen. Wenn Sie unsere Seite
            wieder aufrufen, übermittelt Ihr Browser die „userbezogenen“
            Informationen an unsere Seite zurück. Dank der Cookies weiß unsere
            Website, wer Sie sind und bietet Ihnen die Einstellung, die Sie
            gewohnt sind. In einigen Browsern hat jedes Cookie eine eigene
            Datei, in anderen wie beispielsweise Firefox sind alle Cookies in
            einer einzigen Datei gespeichert.
          </p>
          <p>
            Die folgende Grafik zeigt eine mögliche Interaktion zwischen einem
            Webbrowser wie z. B. Chrome und dem Webserver. Dabei fordert der
            Webbrowser eine Website an und erhält vom Server ein Cookie zurück,
            welches der Browser erneut verwendet, sobald eine andere Seite
            angefordert wird.
          </p>
          <p>
            <img
              src={"https://www.adsimple.at/wp-content/uploads/2018/03/http-cookie-interaction.svg"}
              alt={"HTTP Cookie Interaktion zwischen Browser und Webserver"}
              width={"100%"}
            />
          </p>
          <p>
            Es gibt sowohl Erstanbieter Cookies als auch Drittanbieter-Cookies.
            Erstanbieter-Cookies werden direkt von unserer Seite erstellt,
            Drittanbieter-Cookies werden von Partner-Websites (z.B. Google
            Analytics) erstellt. Jedes Cookie ist individuell zu bewerten, da
            jedes Cookie andere Daten speichert. Auch die Ablaufzeit eines
            Cookies variiert von ein paar Minuten bis hin zu ein paar Jahren.
            Cookies sind keine Software-Programme und enthalten keine Viren,
            Trojaner oder andere „Schädlinge“. Cookies können auch nicht auf
            Informationen Ihres PCs zugreifen.
          </p>
          <p>So können zum Beispiel Cookie-Daten aussehen:</p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> _ga
            <br />
            <strong className="adsimple-111742326">Wert:</strong>
             GA1.2.1326744211.152111742326-9
            <br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Unterscheidung der Websitebesucher
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 2
            Jahren
          </p>
          <p>Diese Mindestgrößen sollte ein Browser unterstützen können:</p>
          <ul className="adsimple-111742326">
            <li className="adsimple-111742326">
              Mindestens 4096 Bytes pro Cookie
            </li>
            <li className="adsimple-111742326">
              Mindestens 50 Cookies pro Domain
            </li>
            <li className="adsimple-111742326">
              Mindestens 3000 Cookies insgesamt
            </li>
          </ul>
          <br /><h3 className="adsimple-111742326">
            Welche Arten von Cookies gibt es?
          </h3>
          <p>
            Die Frage welche Cookies wir im Speziellen verwenden, hängt von den
            verwendeten Diensten ab und wird in den folgenden Abschnitten der
            Datenschutzerklärung geklärt. An dieser Stelle möchten wir kurz auf
            die verschiedenen Arten von HTTP-Cookies eingehen.
          </p>
          <p>Man kann 4 Arten von Cookies unterscheiden:</p>
          <p>
            <strong className="adsimple-111742326">
              Unerlässliche Cookies
              <br />
            </strong>
            Diese Cookies sind nötig, um grundlegende Funktionen der Website
            sicherzustellen. Zum Beispiel braucht es diese Cookies, wenn ein
            User ein Produkt in den Warenkorb legt, dann auf anderen Seiten
            weitersurft und später erst zur Kasse geht. Durch diese Cookies wird
            der Warenkorb nicht gelöscht, selbst wenn der User sein
            Browserfenster schließt.
          </p>
          <p>
            <strong className="adsimple-111742326">
              Zweckmäßige Cookies
              <br />
            </strong>
            Diese Cookies sammeln Infos über das Userverhalten und ob der User
            etwaige Fehlermeldungen bekommt. Zudem werden mithilfe dieser
            Cookies auch die Ladezeit und das Verhalten der Website bei
            verschiedenen Browsern gemessen.
          </p>
          <p>
            <strong className="adsimple-111742326">
              Zielorientierte Cookies
              <br />
            </strong>
            Diese Cookies sorgen für eine bessere Nutzerfreundlichkeit.
            Beispielsweise werden eingegebene Standorte, Schriftgrößen oder
            Formulardaten gespeichert.
          </p>
          <p>
            <strong className="adsimple-111742326">
              Werbe-Cookies
              <br />
            </strong>
            Diese Cookies werden auch Targeting-Cookies genannt. Sie dienen dazu
            dem User individuell angepasste Werbung zu liefern. Das kann sehr
            praktisch, aber auch sehr nervig sein.
          </p>
          <p>
            Üblicherweise werden Sie beim erstmaligen Besuch einer Website
            gefragt, welche dieser Cookiearten Sie zulassen möchten. Und
            natürlich wird diese Entscheidung auch in einem Cookie gespeichert.
          </p>
          <p>
            Wenn Sie mehr über Cookies wissen möchten und technische
            Dokumentationen nicht scheuen, empfehlen wir{" "}
            <a
              className="adsimple-111742326"
              href="https://tools.ietf.org/html/rfc6265"
              target="_blank"
              rel="nofollow noreferrer"
            >
              https://tools.ietf.org/html/rfc6265
            </a>
            , dem Request for Comments der Internet Engineering Task Force
            (IETF) namens “HTTP State Management Mechanism”.
          </p>
          <br /><h3 className="adsimple-111742326">
            Zweck der Verarbeitung über Cookies
          </h3>
          <p>
            Der Zweck ist letztendlich abhängig vom jeweiligen Cookie. Mehr
            Details dazu finden Sie weiter unten bzw. beim Hersteller der
            Software, die das Cookie setzt.
          </p>
          <br /><h3 className="adsimple-111742326">
            Welche Daten werden verarbeitet?
          </h3>
          <p>
            Cookies sind kleine Gehilfen für eine viele verschiedene Aufgaben.
            Welche Daten in Cookies gespeichert werden, kann man leider nicht
            verallgemeinern, aber wir werden Sie im Rahmen der folgenden
            Datenschutzerklärung über die verarbeiteten bzw. gespeicherten Daten
            informieren.
          </p>
          <br /><h3 className="adsimple-111742326">Speicherdauer von Cookies</h3>
          <p>
            Die Speicherdauer hängt vom jeweiligen Cookie ab und wird weiter
            unter präzisiert. Manche Cookies werden nach weniger als einer
            Stunde gelöscht, andere können mehrere Jahre auf einem Computer
            gespeichert bleiben.
          </p>
          <br /><h3 className="adsimple-111742326">
            Widerspruchsrecht – wie kann ich Cookies löschen?
          </h3>
          <p>
            Wie und ob Sie Cookies verwenden wollen, entscheiden Sie selbst.
            Unabhängig von welchem Service oder welcher Website die Cookies
            stammen, haben Sie immer die Möglichkeit Cookies zu löschen, zu
            deaktivieren oder nur teilweise zuzulassen. Zum Beispiel können Sie
            Cookies von Drittanbietern blockieren, aber alle anderen Cookies
            zulassen.
          </p>
          <p>
            Wenn Sie feststellen möchten, welche Cookies in Ihrem Browser
            gespeichert wurden, wenn Sie Cookie-Einstellungen ändern oder
            löschen wollen, können Sie dies in Ihren Browser-Einstellungen
            finden:
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.google.com/chrome/answer/95647?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren
            Browser so einrichten, dass er Sie immer informiert, wenn ein Cookie
            gesetzt werden soll. So können Sie bei jedem einzelnen Cookie
            entscheiden, ob Sie das Cookie erlauben oder nicht. Die
            Vorgangsweise ist je nach Browser verschieden. Am besten Sie suchen
            die Anleitung in Google mit dem Suchbegriff “Cookies löschen Chrome”
            oder “Cookies deaktivieren Chrome” im Falle eines Chrome Browsers.
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Seit 2009 gibt es die sogenannten „Cookie-Richtlinien“. Darin ist
            festgehalten, dass das Speichern von Cookies eine{" "}
            <strong className="adsimple-111742326">Einwilligung</strong>{" "}
            (Artikel 6 Abs. 1 lit. a DSGVO) von Ihnen verlangt. Innerhalb der
            EU-Länder gibt es allerdings noch sehr unterschiedliche Reaktionen
            auf diese Richtlinien. In Österreich erfolgte aber die Umsetzung
            dieser Richtlinie in § 96 Abs. 3 des Telekommunikationsgesetzes
            (TKG). In Deutschland wurden die Cookie-Richtlinien nicht als
            nationales Recht umgesetzt. Stattdessen erfolgte die Umsetzung
            dieser Richtlinie weitgehend in § 15 Abs.3 des Telemediengesetzes
            (TMG).
          </p>
          <p>
            Für unbedingt notwendige Cookies, wo keine Einwilligung vorliegt
            bestehen{" "}
            <strong className="adsimple-111742326">
              berechtigte Interessen
            </strong>{" "}
            (Artikel 6 Abs. 1 lit. f DSGVO), die in den meisten Fällen
            wirtschaftlicher Natur sind. Wir möchten den Besuchern der Website
            eine angenehme Benutzererfahrung bescheren und dafür sind Cookies
            oft unbedingt notwendig.
          </p>
          <p>
            In den folgenden Abschnitten werden Sie genauer über den Einsatz von
            Cookies informiert, sofern eingesetzte Software Cookies verwendet.
          </p>
          <br /><h2 id="web-analytics" className="adsimple-111742326">
            Web Analytics
          </h2>
          <table border="1" cellpadding="15">
            <tbody>
              <tr>
                <td>
                  <strong className="adsimple-111742326">
                  <div className={styles.boxTitle}> Web Analytics Datenschutzerklärung Zusammenfassung
                 </div> </strong>
                  <br /><div className={styles.box}>
                  👥 Betroffene: Besucher der Website
                  <br />
                  🤝 Zweck: Auswertung der Besucherinformationen zur Optimierung
                  des Webangebots.
                  <br />
                  📓 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie
                  Standorte der Zugriffe, Gerätedaten, Zugriffsdauer und
                  Zeitpunkt, Navigationsverhalten, Klickverhalten und
                  IP-Adressen enthalten. Mehr Details dazu finden Sie beim
                  jeweils eingesetzten Web Analytics Tool.
                  <br />
                  📅 Speicherdauer: abhängig vom eingesetzten Web-Analytics-Tool
                  <br />
                  ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO
                  (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                  Interessen)
               </div> </td>
              </tr>
            </tbody>
          </table>
          <br /><h3 className="adsimple-111742326">Was ist Web Analytics?</h3>
          <p>
            Wir verwenden auf unserer Website Software zur Auswertung des
            Verhaltens der Website-Besucher, kurz Web Analytics oder Web-Analyse
            genannt. Dabei werden Daten gesammelt, die der jeweilige
            Analytic-Tool-Anbieter (auch Trackingtool genannt) speichert,
            verwaltet und verarbeitet. Mit Hilfe der Daten werden Analysen über
            das Nutzerverhalten auf unserer Website erstellt und uns als
            Websitebetreiber zur Verfügung gestellt. Zusätzlich bieten die
            meisten Tools verschiedene Testmöglichkeiten an. So können wir etwa
            testen, welche Angebote oder Inhalte bei unseren Besuchern am besten
            ankommen. Dafür zeigen wir Ihnen für einen begrenzten Zeitabschnitt
            zwei verschiedene Angebote. Nach dem Test (sogenannter A/B-Test)
            wissen wir, welches Produkt bzw. welcher Inhalt unsere
            Websitebesucher interessanter finden. Für solche Testverfahren, wie
            auch für andere Analytics-Verfahren, können auch Userprofile
            erstellt werden und die Daten in Cookies gespeichert werden.
          </p>
          <br /><h3 className="adsimple-111742326">
            Warum betreiben wir Web Analytics?
          </h3>
          <p>
            Mit unserer Website haben wir ein klares Ziel vor Augen: wir wollen
            für unsere Branche das besten Webangebot auf dem Markt liefern. Um
            dieses Ziel zu erreichen, wollen wir einerseits das beste und
            interessanteste Angebot bieten und andererseits darauf achten, dass
            Sie sich auf unserer Website rundum wohlfühlen. Mit Hilfe von
            Webanalyse-Tools können wir das Verhalten unserer Websitebesucher
            genauer unter die Lupe nehmen und dann entsprechend unser Webangebot
            für Sie und uns verbessern. So können wir beispielsweise erkennen
            wie alt unsere Besucher durchschnittlich sind, woher sie kommen,
            wann unsere Website am meisten besucht wird oder welche Inhalte oder
            Produkte besonders beliebt sind. All diese Informationen helfen uns
            die Website zu optimieren und somit bestens an Ihre Bedürfnisse,
            Interessen und Wünsche anzupassen.
          </p>
          <br /><h3 className="adsimple-111742326">
            Welche Daten werden verarbeitet?
          </h3>
          <p>
            Welche Daten genau gespeichert werden, hängt natürlich von den
            verwendeten Analyse-Tools ab. Doch in der Regel wird zum Beispiel
            gespeichert, welche Inhalte Sie auf unserer Website ansehen, auf
            welche Buttons oder Links Sie klicken, wann Sie eine Seite aufrufen,
            welchen Browser sie verwenden, mit welchem Gerät (PC, Tablet,
            Smartphone usw.) Sie die Website besuchen oder welches
            Computersystem Sie verwenden. Wenn Sie damit einverstanden waren,
            dass auch Standortdaten erhoben werden dürfen, können auch diese
            durch den Webanalyse-Tool-Anbieter verarbeitet werden.
          </p>
          <p>
            Zudem wird auch Ihre IP-Adresse gespeichert. Gemäß der
            Datenschutz-Grundverordnung (DSGVO) sind IP-Adressen
            personenbezogene Daten. Ihre IP-Adresse wird allerdings in der Regel
            pseudonymisiert (also in unkenntlicher und gekürzter Form)
            gespeichert. Für den Zweck der Tests, der Webanalyse und der
            Weboptimierung werden grundsätzlich keine direkten Daten, wie etwa
            Ihr Name, Ihr Alter, Ihre Adresse oder Ihre E-Mail-Adresse
            gespeichert. All diese Daten werden, sofern sie erhoben werden,
            pseudonymisiert gespeichert. So können Sie als Person nicht
            identifiziert werden.
          </p>
          <p>
            Das folgende Beispiel zeigt schematisch die Funktionsweise von
            Google Analytics als Beispiel für client-basiertes Webtracking mit
            Java-Script-Code.
          </p>
          <p>
            <img
              src={"https://www.adsimple.at/wp-content/uploads/2021/04/google-analytics-dataflow.svg"}
              alt={"Schematischer Datenfluss bei Google Analytics"}
              width={"100%"}
            />
          </p>
          <p>
            Wie lange die jeweiligen Daten gespeichert werden, hängt immer vom
            Anbieter ab. Manche Cookies speichern Daten nur für ein paar Minuten
            bzw. bis Sie die Website wieder verlassen, andere Cookies können
            Daten über mehrere Jahre speichern.
          </p>
          <br /><h3 className="adsimple-111742326">Dauer der Datenverarbeitung</h3>
          <p>
            Über die Dauer der Datenverarbeitung informieren wir Sie weiter
            unten, sofern wir weitere Informationen dazu haben. Generell
            verarbeiten wir personenbezogene Daten nur so lange wie es für die
            Bereitstellung unserer Dienstleistungen und Produkte unbedingt
            notwendig ist. Wenn es, wie zum Beispiel im Fall von Buchhaltung,
            gesetzlich vorgeschrieben ist, kann diese Speicherdauer auch
            überschritten werden.
          </p>
          <br /><h3 className="adsimple-111742326">Widerspruchsrecht</h3>
          <p>
            Sie haben auch jederzeit das Recht und die Möglichkeit Ihre
            Einwilligung zur Verwendung von Cookies bzw. Drittanbietern zu
            widerrufen. Das funktioniert entweder über unser
            Cookie-Management-Tool oder über andere Opt-Out-Funktionen. Zum
            Beispiel können Sie auch die Datenerfassung durch Cookies
            verhindern, indem Sie in Ihrem Browser die Cookies verwalten,
            deaktivieren oder löschen.
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Der Einsatz von Web-Analytics setzt Ihre Einwilligung voraus, welche
            wir mit unserem Cookie Popup eingeholt haben. Diese Einwilligung
            stellt laut
            <strong className="adsimple-111742326">
              {" "}
              Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
            </strong>{" "}
            die Rechtsgrundlage für die Verarbeitung personenbezogener Daten,
            wie sie bei der Erfassung durch Web-Analytics Tools vorkommen kann,
            dar.
          </p>
          <p>
            Zusätzlich zur Einwilligung besteht von unserer Seite ein
            berechtigtes Interesse daran, dass Verhalten der Websitebesucher zu
            analysieren und so unser Angebot technisch und wirtschaftlich zu
            verbessern. Mit Hilfe von Web-Analytics erkennen wir Fehler der
            Website, können Attacken identifizieren und die Wirtschaftlichkeit
            verbessern. Die Rechtsgrundlage dafür ist 
            <strong className="adsimple-111742326">
              Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
            </strong>
            .
          </p>
          <p>
            Da bei Web-Analytics-Tools Cookies zum Einsatz kommen, empfehlen wir
            Ihnen auch das Lesen unserer allgemeinen Datenschutzerklärung zu
            Cookies. Um zu erfahren, welche Daten von Ihnen genau gespeichert
            und verarbeitet werden, sollten Sie die Datenschutzerklärungen der
            jeweiligen Tools durchlesen.
          </p>
          <p>
            Informationen zu speziellen Web-Analytics-Tools, erhalten Sie –
            sofern vorhanden – in den folgenden Abschnitten.
          </p>
          <br /><h2
            id="google-analytics-datenschutzerklaerung"
            className="adsimple-111742326"
          >
            Google Analytics Datenschutzerklärung
          </h2>
          <table border="1" cellpadding="15">
            <tbody>
              <tr>
                <td>
                  <strong className="adsimple-111742326">
                  <div className={styles.boxTitle}>Google Analytics Datenschutzerklärung Zusammenfassung
                 </div> </strong>
                  <br /><div className={styles.box}>
                  👥 Betroffene: Besucher der Website
                  <br />
                  🤝 Zweck: Auswertung der Besucherinformationen zur Optimierung
                  des Webangebots.
                  <br />
                  📓 Verarbeitete Daten: Zugriffsstatistiken, die Daten wie
                  Standorte der Zugriffe, Gerätedaten, Zugriffsdauer und
                  Zeitpunkt, Navigationsverhalten, Klickverhalten und
                  IP-Adressen enthalten. Mehr Details dazu finden Sie weiter
                  unten in dieser Datenschutzerklärung.
                  <br />
                  📅 Speicherdauer: abhängig von den verwendeten Properties
                  <br />
                  ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO
                  (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                  Interessen)
              </div>  </td>
              </tr>
            </tbody>
          </table>
          <br /><h3 className="adsimple-111742326">Was ist Google Analytics?</h3>
          <p>
            Wir verwenden auf unserer Website das Analyse-Tracking Tool Google
            Analytics (GA) des amerikanischen Unternehmens Google Inc. Für den
            europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon
            House, Barrow Street Dublin 4, Irland) für alle Google-Dienste
            verantwortlich. Google Analytics sammelt Daten über Ihre Handlungen
            auf unserer Website. Wenn Sie beispielsweise einen Link anklicken,
            wird diese Aktion in einem Cookie gespeichert und an Google
            Analytics versandt. Mithilfe der Berichte, die wir von Google
            Analytics erhalten, können wir unsere Website und unser Service
            besser an Ihre Wünsche anpassen. Im Folgenden gehen wir näher auf
            das Tracking-Tool ein und informieren Sie vor allem darüber, welche
            Daten gespeichert werden und wie Sie das verhindern können.
          </p>
          <p>
            Google Analytics ist ein Trackingtool, das der Datenverkehrsanalyse
            unserer Website dient. Damit Google Analytics funktioniert, wird ein
            Tracking-Code in den Code unserer Website eingebaut. Wenn Sie unsere
            Website besuchen, zeichnet dieser Code verschiedene Handlungen auf,
            die Sie auf unserer Website ausführen. Sobald Sie unsere Website
            verlassen, werden diese Daten an die Google-Analytics-Server
            gesendet und dort gespeichert.
          </p>
          <p>
            Google verarbeitet die Daten und wir bekommen Berichte über Ihr
            Userverhalten. Dabei kann es sich unter anderem um folgende Berichte
            handeln:
          </p>
          <ul className="adsimple-111742326">
            <li className="adsimple-111742326">
              Zielgruppenberichte: Über Zielgruppenberichte lernen wir unsere
              User besser kennen und wissen genauer, wer sich für unser Service
              interessiert.
            </li>
            <li className="adsimple-111742326">
              Anzeigeberichte: Durch Anzeigeberichte können wir unsere
              Onlinewerbung leichter analysieren und verbessern.
            </li>
            <li className="adsimple-111742326">
              Akquisitionsberichte: Akquisitionsberichte geben uns hilfreiche
              Informationen darüber, wie wir mehr Menschen für unser Service
              begeistern können.
            </li>
            <li className="adsimple-111742326">
              Verhaltensberichte: Hier erfahren wir, wie Sie mit unserer Website
              interagieren. Wir können nachvollziehen welchen Weg Sie auf
              unserer Seite zurücklegen und welche Links Sie anklicken.
            </li>
            <li className="adsimple-111742326">
              Conversionsberichte: Conversion nennt man einen Vorgang, bei dem
              Sie aufgrund einer Marketing-Botschaft eine gewünschte Handlung
              ausführen. Zum Beispiel, wenn Sie von einem reinen Websitebesucher
              zu einem Käufer oder Newsletter-Abonnent werden. Mithilfe dieser
              Berichte erfahren wir mehr darüber, wie unsere Marketing-Maßnahmen
              bei Ihnen ankommen. So wollen wir unsere Conversionrate steigern.
            </li>
            <li className="adsimple-111742326">
              Echtzeitberichte: Hier erfahren wir immer sofort, was gerade auf
              unserer Website passiert. Zum Beispiel sehen wir wie viele User
              gerade diesen Text lesen.
            </li>
          </ul>
          <br /><h3 className="adsimple-111742326">
            Warum verwenden wir Google Analytics auf unserer Website?
          </h3>
          <p>
            Unser Ziel mit dieser Website ist klar: Wir wollen Ihnen das
            bestmögliche Service bieten. Die Statistiken und Daten von Google
            Analytics helfen uns dieses Ziel zu erreichen.
          </p>
          <p>
            Die statistisch ausgewerteten Daten zeigen uns ein klares Bild von
            den Stärken und Schwächen unserer Website. Einerseits können wir
            unsere Seite so optimieren, dass sie von interessierten Menschen auf
            Google leichter gefunden wird. Andererseits helfen uns die Daten,
            Sie als Besucher besser zu verstehen. Wir wissen somit sehr genau,
            was wir an unserer Website verbessern müssen, um Ihnen das
            bestmögliche Service zu bieten. Die Daten dienen uns auch, unsere
            Werbe- und Marketing-Maßnahmen individueller und kostengünstiger
            durchzuführen. Schließlich macht es nur Sinn, unsere Produkte und
            Dienstleistungen Menschen zu zeigen, die sich dafür interessieren.
          </p>
          <br /><h3 className="adsimple-111742326">
            Welche Daten werden von Google Analytics gespeichert?
          </h3>
          <p>
            Google Analytics erstellt mithilfe eines Tracking-Codes eine
            zufällige, eindeutige ID, die mit Ihrem Browser-Cookie verbunden
            ist. So erkennt Sie Google Analytics als neuen User. Wenn Sie das
            nächste Mal unsere Seite besuchen, werden Sie als „wiederkehrender“
            User erkannt. Alle gesammelten Daten werden gemeinsam mit dieser
            User-ID gespeichert. So ist es überhaupt erst möglich pseudonyme
            Userprofile auszuwerten.
          </p>
          <p>
            Um mit Google Analytics unsere Website analysieren zu können, muss
            eine Property-ID in den Tracking-Code eingefügt werden. Die Daten
            werden dann in der entsprechenden Property gespeichert. Für jede neu
            angelegte Property ist die Google Analytics 4-Property
            standardmäßig. Alternativ kann man aber auch noch die Universal
            Analytics Property erstellen. Je nach verwendeter Property werden
            Daten unterschiedlich lange gespeichert.
          </p>
          <p>
            Durch Kennzeichnungen wie Cookies und App-Instanz-IDs werden Ihre
            Interaktionen auf unserer Website gemessen. Interaktionen sind alle
            Arten von Handlungen, die Sie auf unserer Website ausführen. Wenn
            Sie auch andere Google-Systeme (wie z.B. ein Google-Konto) nützen,
            können über Google Analytics generierte Daten mit
            Drittanbieter-Cookies verknüpft werden. Google gibt keine Google
            Analytics-Daten weiter, außer wir als Websitebetreiber genehmigen
            das. Zu Ausnahmen kann es kommen, wenn es gesetzlich erforderlich
            ist.
          </p>
          <p>Folgende Cookies werden von Google Analytics verwendet:</p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> _ga
            <br />
            <strong className="adsimple-111742326">Wert: </strong>
            2.1326744211.152111742326-5
            <br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Standardmäßig verwendet analytics.js das Cookie _ga, um die User-ID
            zu speichern. Grundsätzlich dient es zur Unterscheidung der
            Webseitenbesucher.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 2
            Jahren
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> _gid
            <br />
            <strong className="adsimple-111742326">Wert: </strong>
            2.1687193234.152111742326-1
            <br />
            <strong className="adsimple-111742326">Verwendungszweck:</strong>
             Das Cookie dient auch zur Unterscheidung der Webseitenbesucher
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 24
            Stunden
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> _gat_gtag_UA_
            <br />
            <strong className="adsimple-111742326">Wert:</strong> 1<br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Wird zum Senken der Anforderungsrate verwendet. Wenn Google
            Analytics über den Google Tag Manager bereitgestellt wird, erhält
            dieser Cookie den Namen _dc_gtm_ .<br />
            <strong className="adsimple-111742326">Ablaufdatum: </strong>nach 1
            Minute
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> AMP_TOKEN
            <br />
            <strong className="adsimple-111742326">Wert:</strong> keine Angaben
            <br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Das Cookie hat einen Token, mit dem eine User ID vom
            AMP-Client-ID-Dienst abgerufen werden kann. Andere mögliche Werte
            weisen auf eine Abmeldung, eine Anfrage oder einen Fehler hin.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 30
            Sekunden bis zu einem Jahr
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> __utma
            <br />
            <strong className="adsimple-111742326">Wert: </strong>
            1564498958.1564498958.1564498958.1
            <br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Mit diesem Cookie kann man Ihr Verhalten auf der Website verfolgen
            und die Leistung messen. Das Cookie wird jedes Mal aktualisiert,
            wenn Informationen an Google Analytics gesendet werden.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 2
            Jahren
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> __utmt
            <br />
            <strong className="adsimple-111742326">Wert:</strong> 1<br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Das Cookie wird wie _gat_gtag_UA_ zum Drosseln der Anforderungsrate
            verwendet.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 10
            Minuten
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> __utmb
            <br />
            <strong className="adsimple-111742326">Wert: </strong>
            3.10.1564498958
            <br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Dieses Cookie wird verwendet, um neue Sitzungen zu bestimmen. Es
            wird jedes Mal aktualisiert, wenn neue Daten bzw. Infos an Google
            Analytics gesendet werden.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 30
            Minuten
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> __utmc
            <br />
            <strong className="adsimple-111742326">Wert:</strong> 167421564
            <br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Dieses Cookie wird verwendet, um neue Sitzungen für wiederkehrende
            Besucher festzulegen. Dabei handelt es sich um ein Session-Cookie
            und wird nur solange gespeichert, bis Sie den Browser wieder
            schließen.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> Nach
            Schließung des Browsers
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> __utmz
            <br />
            <strong className="adsimple-111742326">Wert:</strong>{" "}
            m|utmccn=(referral)|utmcmd=referral|utmcct=/
            <br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Das Cookie wird verwendet, um die Quelle des Besucheraufkommens auf
            unserer Website zu identifizieren. Das heißt, das Cookie speichert,
            von wo Sie auf unsere Website gekommen sind. Das kann eine andere
            Seite bzw. eine Werbeschaltung gewesen sein.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 6
            Monaten
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> __utmv
            <br />
            <strong className="adsimple-111742326">Wert:</strong> keine Angabe
            <br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Das Cookie wird verwendet, um benutzerdefinierte Userdaten zu
            speichern. Es wird immer aktualisiert, wenn Informationen an Google
            Analytics gesendet werden.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 2
            Jahren
          </p>
          <p>
            <strong className="adsimple-111742326">Anmerkung:</strong> Diese
            Aufzählung kann keinen Anspruch auf Vollständigkeit erheben, da
            Google die Wahl ihrer Cookies immer wieder auch verändert.
          </p>
          <p>
            Hier zeigen wir Ihnen einen Überblick über die wichtigsten Daten,
            die mit Google Analytics erhoben werden:
          </p>
          <p>
            <strong className="adsimple-111742326">Heatmaps:</strong> Google
            legt sogenannte Heatmaps an. Über Heatmaps sieht man genau jene
            Bereiche, die Sie anklicken. So bekommen wir Informationen, wo Sie
            auf unserer Seite „unterwegs“ sind.
          </p>
          <p>
            <strong className="adsimple-111742326">Sitzungsdauer:</strong> Als
            Sitzungsdauer bezeichnet Google die Zeit, die Sie auf unserer Seite
            verbringen, ohne die Seite zu verlassen. Wenn Sie 20 Minuten inaktiv
            waren, endet die Sitzung automatisch.
          </p>
          <p>
            <strong className="adsimple-111742326">Absprungrate</strong> (engl.
            Bouncerate): Von einem Absprung ist die Rede, wenn Sie auf unserer
            Website nur eine Seite ansehen und dann unsere Website wieder
            verlassen.
          </p>
          <p>
            <strong className="adsimple-111742326">Kontoerstellung:</strong>{" "}
            Wenn Sie auf unserer Website ein Konto erstellen bzw. eine
            Bestellung machen, erhebt Google Analytics diese Daten.
          </p>
          <p>
            <strong className="adsimple-111742326">IP-Adresse:</strong> Die
            IP-Adresse wird nur in gekürzter Form dargestellt, damit keine
            eindeutige Zuordnung möglich ist.
          </p>
          <p>
            <strong className="adsimple-111742326">Standort:</strong> Über die
            IP-Adresse kann das Land und Ihr ungefährer Standort bestimmt
            werden. Diesen Vorgang bezeichnet man auch als IP-
            Standortbestimmung.
          </p>
          <p>
            <strong className="adsimple-111742326">
              Technische Informationen:
            </strong>{" "}
            Zu den technischen Informationen zählen unter anderem Ihr
            Browsertyp, Ihr Internetanbieter oder Ihre Bildschirmauflösung.
          </p>
          <p>
            <strong className="adsimple-111742326">Herkunftsquelle:</strong>{" "}
            Google Analytics beziehungsweise uns interessiert natürlich auch
            über welche Website oder welche Werbung Sie auf unsere Seite
            gekommen sind.
          </p>
          <p>
            Weitere Daten sind Kontaktdaten, etwaige Bewertungen, das Abspielen
            von Medien (z.B., wenn Sie ein Video über unsere Seite abspielen),
            das Teilen von Inhalten über Social Media oder das Hinzufügen zu
            Ihren Favoriten. Die Aufzählung hat keinen Vollständigkeitsanspruch
            und dient nur zu einer allgemeinen Orientierung der Datenspeicherung
            durch Google Analytics.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie lange und wo werden die Daten gespeichert?
          </h3>
          <p>
            Google hat Ihre Server auf der ganzen Welt verteilt. Die meisten
            Server befinden sich in Amerika und folglich werden Ihre Daten meist
            auf amerikanischen Servern gespeichert. Hier können Sie genau
            nachlesen wo sich die Google-Rechenzentren befinden:{" "}
            <a
              className="adsimple-111742326"
              href="https://www.google.com/about/datacenters/inside/locations/?hl=de"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://www.google.com/about/datacenters/inside/locations/?hl=de
            </a>
          </p>
          <p>
            Ihre Daten werden auf verschiedenen physischen Datenträgern
            verteilt. Das hat den Vorteil, dass die Daten schneller abrufbar
            sind und vor Manipulation besser geschützt sind. In jedem
            Google-Rechenzentrum gibt es entsprechende Notfallprogramme für Ihre
            Daten. Wenn beispielsweise die Hardware bei Google ausfällt oder
            Naturkatastrophen Server lahmlegen, bleibt das Risiko einer
            Dienstunterbrechung bei Google dennoch gering.
          </p>
          <p>
            Die Aufbewahrungsdauer der Daten hängt von den verwendeten
            Properties ab. Bei der Verwendung der neueren Google Analytics
            4-Properties ist die Aufbewahrungsdauer Ihrer Userdaten auf 14
            Monate fix eingestellt. Für andere sogenannte Ereignisdaten haben
            wir die Möglichkeit eine Aufbewahrungsdauer von 2 Monaten oder 14
            Monaten zu wählen.
          </p>
          <p>
            Bei Universal Analytics-Properties ist bei Google Analytics eine
            Aufbewahrungsdauer Ihrer Userdaten von 26 Monaten standardisiert
            eingestellt. Dann werden Ihre Userdaten gelöscht. Allerdings haben
            wir die Möglichkeit, die Aufbewahrungsdauer von Nutzdaten selbst zu
            wählen. Dafür stehen uns fünf Varianten zur Verfügung:
          </p>
          <ul className="adsimple-111742326">
            <li className="adsimple-111742326">Löschung nach 14 Monaten</li>
            <li className="adsimple-111742326">Löschung nach 26 Monaten</li>
            <li className="adsimple-111742326">Löschung nach 38 Monaten</li>
            <li className="adsimple-111742326">Löschung nach 50 Monaten</li>
            <li className="adsimple-111742326">Keine automatische Löschung</li>
          </ul>
          <p>
            Zusätzlich gibt es auch die Option, dass Daten erst dann gelöscht
            werden, wenn Sie innerhalb des von uns gewählten Zeitraums nicht
            mehr unsere Website besuchen. In diesem Fall wird die
            Aufbewahrungsdauer jedes Mal zurückgesetzt, wenn Sie unsere Website
            innerhalb des festgelegten Zeitraums wieder besuchen.
          </p>
          <p>
            Wenn der festgelegte Zeitraum abgelaufen ist, werden einmal im Monat
            die Daten gelöscht. Diese Aufbewahrungsdauer gilt für Ihre Daten,
            die mit Cookies, Usererkennung und Werbe-IDs (z.B. Cookies der
            DoubleClick-Domain) verknüpft sind. Berichtergebnisse basieren auf
            aggregierten Daten und werden unabhängig von Nutzerdaten
            gespeichert. Aggregierte Daten sind eine Zusammenschmelzung von
            Einzeldaten zu einer größeren Einheit.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung
            verhindern?
          </h3>
          <p>
            Nach dem Datenschutzrecht der Europäischen Union haben Sie das
            Recht, Auskunft über Ihre Daten zu erhalten, sie zu aktualisieren,
            zu löschen oder einzuschränken. Mithilfe des Browser-Add-ons zur
            Deaktivierung von Google Analytics-JavaScript (ga.js, analytics.js,
            dc.js) verhindern Sie, dass Google Analytics Ihre Daten verwendet.
            Das Browser-Add-on können Sie unter{" "}
            <a
              className="adsimple-111742326"
              href="https://tools.google.com/dlpage/gaoptout?hl=de"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://tools.google.com/dlpage/gaoptout?hl=de
            </a>{" "}
            runterladen und installieren. Beachten Sie bitte, dass durch dieses
            Add-on nur die Datenerhebung durch Google Analytics deaktiviert
            wird.
          </p>
          <p>
            Falls Sie grundsätzlich Cookies (unabhängig von Google Analytics)
            deaktivieren, löschen oder verwalten wollen, gibt es für jeden
            Browser eine eigene Anleitung:
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.google.com/chrome/answer/95647?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Bitte beachten Sie, dass bei der Verwendung dieses Tools Daten von
            Ihnen auch außerhalb der EU gespeichert und verarbeitet werden
            können. Die meisten Drittstaaten (darunter auch die USA) gelten nach
            derzeitigem europäischen Datenschutzrecht als nicht sicher. Daten an
            unsichere Drittstaaten dürfen also nicht einfach übertragen, dort
            gespeichert und verarbeitet werden, sofern es keine passenden
            Garantien (wie etwa EU-Standardvertragsklauseln) zwischen uns und
            dem außereuropäischen Dienstleister gibt.
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Der Einsatz von Google Analytics setzt Ihre Einwilligung voraus,
            welche wir mit unserem Cookie Popup eingeholt haben. Diese
            Einwilligung stellt laut
            <strong className="adsimple-111742326">
              {" "}
              Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
            </strong>{" "}
            die Rechtsgrundlage für die Verarbeitung personenbezogener Daten,
            wie sie bei der Erfassung durch Web-Analytics Tools vorkommen kann,
            dar.
          </p>
          <p>
            Zusätzlich zur Einwilligung besteht von unserer Seite ein
            berechtigtes Interesse daran, dass Verhalten der Websitebesucher zu
            analysieren und so unser Angebot technisch und wirtschaftlich zu
            verbessern. Mit Hilfe von Google Analytics erkennen wir Fehler der
            Website, können Attacken identifizieren und die Wirtschaftlichkeit
            verbessern. Die Rechtsgrundlage dafür ist{" "}
            <strong className="adsimple-111742326">
              Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
            </strong>
            .
          </p>
          <p>
            Wir hoffen, wir konnten Ihnen die wichtigsten Informationen rund um
            die Datenverarbeitung von Google Analytics näherbringen. Wenn Sie
            mehr über den Tracking-Dienst erfahren wollen, empfehlen wir diese
            beiden Links:{" "}
            <a
              className="adsimple-111742326"
              href="http://www.google.com/analytics/terms/de.html"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              http://www.google.com/analytics/terms/de.html
            </a>{" "}
            und{" "}
            <a
              className="adsimple-111742326"
              href="https://support.google.com/analytics/answer/6004245?hl=de"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://support.google.com/analytics/answer/6004245?hl=de
            </a>
            .
          </p>
          <br /><h2
            id="adsimple-cookie-manager-datenschutzerklaerung"
            className="adsimple-111742326"
          >
            AdSimple Cookie Manager Datenschutzerklärung
          </h2>
          <table border="1" cellpadding="15">
            <tbody>
              <tr>
                <td>
                  <strong className="adsimple-111742326">
                  <div className={styles.boxTitle}> AdSimple Cookie Manager Datenschutzerklärung Zusammenfassung
                  </div></strong>
                  <br /><div className={styles.box}>
                  👥 Betroffene: Website Besucher
                  <br />
                  🤝 Zweck: Einholung der Zustimmung zu bestimmten Cookies und
                  somit dem Einsatz bestimmter Tools
                  <br />
                  📓 Verarbeitete Daten: Daten zur Verwaltung der eingestellten
                  Cookie-Einstellungen wie IP-Adresse, Zeitpunkt der Zustimmung,
                  Art der Zustimmung, einzelne Zustimmungen. Mehr Details dazu
                  finden Sie weiter unter in dieser Datenschutzerklärung
                  <br />
                  📅 Speicherdauer: das verwendete Cookie läuft nach einem Jahr
                  ab
                  <br />
                  ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO
                  (Einwilligung), Art. 6 Abs. 1 lit.f DSGVO (berechtigte
                  Interessen)
                </div></td>
              </tr>
            </tbody>
          </table>
          <br /><h3 className="adsimple-111742326">
            Was ist der AdSimple Cookie Manager?
          </h3>
          <p>
            Wir verwenden auf unserer Website den AdSimple Cookie Manager des
            Softwareentwicklungs- und Online-Marketing Unternehmens AdSimple
            GmbH, Fabriksgasse 20, 2230 Gänserndorf. Der AdSimple Cookie Manager
            bietet uns unter anderem die Möglichkeit, Ihnen einen umfangreichen
            und datenschutzkonformen Cookie-Hinweis zu liefern, damit Sie selbst
            entscheiden können, welche Cookies Sie zulassen und welche nicht.
            Durch die Verwendung dieser Software werden Daten von Ihnen an
            AdSimple gesendet und gespeichert. In dieser Datenschutzerklärung
            informieren wir Sie, warum wir den AdSimple Cookie Manager
            verwenden, welche Daten übertragen und gespeichert werden und wie
            Sie diese Datenübertragung verhindern können.
          </p>
          <p>
            Der AdSimple Cookie Manager ist eine Software, die unsere Website
            scannt und alle vorhandenen Cookies identifiziert und kategorisiert.
            Zudem werden Sie als Websitebesucher über ein Cookie Hinweis Script
            über die Verwendung von Cookies informiert und entscheiden selbst
            welche Cookies Sie zulassen und welche nicht.
          </p>
          <br /><h3 className="adsimple-111742326">
            Warum verwenden wir den AdSimple Cookie Manager auf unserer Website?
          </h3>
          <p>
            Wir wollen Ihnen maximale Transparenz im Bereich Datenschutz bieten.
            Um das zu gewährleisten, müssen wir zuerst genau wissen, welche
            Cookies im Laufe der Zeit auf unserer Website gelandet sind.
            Dadurch, dass der Cookie Manager von AdSimple regelmäßig unsere
            Website scannt und alle Cookies ausfindig macht, haben wir die volle
            Kontrolle über diese Cookies und können so DSGVO-konform handeln.
            Wir können Sie dadurch über die Nutzung der Cookies auf unserer
            Website genau informieren. Weiters bekommen Sie stets einen
            aktuellen und datenschutzkonformen Cookie-Hinweis und entscheiden
            per Checkbox-System selbst, welche Cookies Sie akzeptieren bzw.
            blockieren.
          </p>
          <br /><h3 className="adsimple-111742326">
            Welche Daten werden von dem AdSimple Cookie Manager gespeichert?
          </h3>
          <p>
            Wenn Sie Cookies auf unserer Website zustimmen, wird folgendes
            Cookie von dem AdSimple Cookie Manager gesetzt:
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> acm_status
            <br />
            <strong className="adsimple-111742326">Wert:</strong>{" "}
            ":true,”statistik”:true,”marketing”:true,”socialmedia”:true,”einstellungen”:true
            <br />
            <strong className="adsimple-111742326">Verwendungszweck:</strong> In
            diesem Cookie wird Ihr Zustimmungsstatus, gespeichert. Dadurch kann
            unsere Website auch bei zukünftigen Besuchen den aktuellen Status
            lesen und befolgen.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach
            einem Jahr
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie lange und wo werden die Daten gespeichert?
          </h3>
          <p>
            Alle Daten, die durch den AdSimple Cookie Manager erhoben werden,
            werden ausschließlich innerhalb der Europäischen Union übertragen
            und gespeichert. Die erhobenen Daten werden auf den Servern von
            AdSimple bei der Hetzner GmbH in Deutschland gespeichert. Zugriff
            auf diese Daten hat ausschließlich die AdSimple GmbH und die Hetzner
            GmbH.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung
            verhindern?
          </h3>
          <p>
            Sie haben jederzeit das Recht auf Ihre personenbezogenen Daten
            zuzugreifen und sie auch zu löschen. Die Datenerfassung und
            Speicherung können Sie beispielsweise verhindern, indem Sie über das
            Cookie-Hinweis-Script die Verwendung von Cookies ablehnen. Eine
            weitere Möglichkeit die Datenverarbeitung zu unterbinden bzw. nach
            Ihren Wünschen zu verwalten, bietet Ihr Browser. Je nach Browser
            funktioniert die Cookie-Verwaltung etwas anders. Hier finden Sie die
            Anleitungen zu den momentan bekanntesten Browsern:
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.google.com/chrome/answer/95647?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Wenn Sie Cookies zustimmen, werden über diese Cookies
            personenbezogene Daten von Ihnen verarbeitet und gespeichert. Falls
            wir durch Ihre{" "}
            <strong className="adsimple-111742326">Einwilligung</strong>{" "}
            (Artikel 6 Abs. 1 lit. a DSGVO) Cookies verwenden dürfen, ist diese
            Einwilligung auch gleichzeitig die Rechtsgrundlage für die
            Verwendung von Cookies bzw. die Verarbeitung Ihrer Daten. Um die
            Einwilligung zu Cookies verwalten zu können und Ihnen die
            Einwilligung ermöglichen zu können, kommt der AdSimple Cookie
            Manager zum Einsatz. Der Einsatz dieser Software ermöglicht uns, die
            Website auf effiziente Weise rechtskonform zu betreiben, was ein{" "}
            <strong className="adsimple-111742326">
              berechtigtes Interesse
            </strong>{" "}
            (Artikel 6 Abs. 1 lit. f DSGVO) darstellt.
          </p>
          <p>
            Wir hoffen, wir haben Ihnen einen guten Überblick über den
            Datenverkehr und die Datenverarbeitung durch den AdSimple Cookie
            Manager geliefert. Wenn Sie mehr über dieses Tool erfahren wollen,
            empfehlen wir Ihnen die Beschreibungsseite auf{" "}
            <a
              className="adsimple-111742326"
              href="https://www.adsimple.at/adsimple-cookie-manager/?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://www.adsimple.at/adsimple-cookie-manager/.
            </a>
          </p>
          <br /><h2
            id="facebook-datenschutzerklaerung"
            className="adsimple-111742326"
          >
            Facebook Datenschutzerklärung
          </h2>
          <table border="1" cellpadding="15">
            <tbody>
              <tr>
                <td>
                  <strong className="adsimple-111742326">
                  <div className={styles.boxTitle}>Facebook Datenschutzerklärung Zusammenfassung</div>
                  </strong>
                  <br /><div className={styles.box}>
                  👥 Betroffene: Besucher der Website
                  <br />
                  🤝 Zweck: Optimierung unserer Serviceleistung
                  <br />
                  📓 Verarbeitete Daten: Daten wie etwa Kundendaten, Daten zum
                  Nutzerverhalten, Informationen zu Ihrem Gerät und Ihre
                  IP-Adresse.
                  <br />
                  Mehr Details dazu finden Sie weiter unten in der
                  Datenschutzerklärung.
                  <br />
                  📅 Speicherdauer: bis die Daten für Facebooks Zwecke nicht
                  mehr nützlich sind
                  <br />
                  ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO
                  (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                  Interessen)
                </div></td>
              </tr>
            </tbody>
          </table>
          <br /><h3 className="adsimple-111742326">Was sind Facebook-Tools?</h3>
          <p>
            Wir verwenden auf unserer Webseite ausgewählte Tools von Facebook.
            Facebook ist ein Social Media Network des Unternehmens Facebook
            Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2
            Ireland. Mithilfe dieser Tools können wir Ihnen und Menschen, die
            sich für unsere Produkte und Dienstleistungen interessieren, das
            bestmögliche Angebot bieten. Im Folgenden geben wir einen Überblick
            über die verschiedenen Facebook Tools, welche Daten an Facebook
            gesendet werden und wie Sie diese Daten löschen können.
          </p>
          <p>
            Neben vielen anderen Produkten bietet Facebook auch die sogenannten
            “Facebook Business Tools” an. Das ist die offizielle Bezeichnung von
            Facebook. Da der Begriff aber kaum bekannt ist, haben wir uns dafür
            entschieden, sie lediglich Facebook-Tools zu nennen. Darunter finden
            sich unter anderem:
          </p>
          <ul className="adsimple-111742326">
            <li className="adsimple-111742326">Facebook-Pixel</li>
            <li className="adsimple-111742326">
              soziale Plug-ins (wie z.B der „Gefällt mir“- oder „Teilen“-Button)
            </li>
            <li className="adsimple-111742326">Facebook Login</li>
            <li className="adsimple-111742326">Account Kit</li>
            <li className="adsimple-111742326">
              APIs (Programmierschnittstelle)
            </li>
            <li className="adsimple-111742326">
              SDKs (Sammlung von Programmierwerkzeugen)
            </li>
            <li className="adsimple-111742326">Plattform-Integrationen</li>
            <li className="adsimple-111742326">Plugins</li>
            <li className="adsimple-111742326">Codes</li>
            <li className="adsimple-111742326">Spezifikationen</li>
            <li className="adsimple-111742326">Dokumentationen</li>
            <li className="adsimple-111742326">
              Technologien und Dienstleistungen
            </li>
          </ul>
          <p>
            Durch diese Tools erweitert Facebook Dienstleistungen und hat die
            Möglichkeit, Informationen über User-Aktivitäten außerhalb von
            Facebook zu erhalten.
          </p>
          <br /><h3 className="adsimple-111742326">
            Warum verwenden wir Facebook-Tools auf unserer Website?
          </h3>
          <p>
            Wir wollen unsere Dienstleistungen und Produkte nur Menschen zeigen,
            die sich auch wirklich dafür interessieren. Mithilfe von
            Werbeanzeigen (Facebook-Ads) können wir genau diese Menschen
            erreichen. Damit den Usern passende Werbung gezeigt werden kann,
            benötigt Facebook allerdings Informationen über die Wünsche und
            Bedürfnisse der Menschen. So werden dem Unternehmen Informationen
            über das Userverhalten (und Kontaktdaten) auf unserer Webseite zur
            Verfügung gestellt. Dadurch sammelt Facebook bessere User-Daten und
            kann interessierten Menschen die passende Werbung über unsere
            Produkte bzw. Dienstleistungen anzeigen. Die Tools ermöglichen somit
            maßgeschneiderte Werbekampagnen auf Facebook.
          </p>
          <p>
            Daten über Ihr Verhalten auf unserer Webseite nennt Facebook
            „Event-Daten“. Diese werden auch für Messungs- und Analysedienste
            verwendet. Facebook kann so in unserem Auftrag „Kampagnenberichte“
            über die Wirkung unserer Werbekampagnen erstellen. Weiters bekommen
            wir durch Analysen einen besseren Einblick, wie Sie unsere
            Dienstleistungen, Webseite oder Produkte verwenden. Dadurch
            optimieren wir mit einigen dieser Tools Ihre Nutzererfahrung auf
            unserer Webseite. Beispielsweise können Sie mit den sozialen
            Plug-ins Inhalte auf unserer Seite direkt auf Facebook teilen.
          </p>
          <br /><h3 className="adsimple-111742326">
            Welche Daten werden von Facebook-Tools gespeichert?
          </h3>
          <p>
            Durch die Nutzung einzelner Facebook-Tools können personenbezogene
            Daten (Kundendaten) an Facebook gesendet werden. Abhängig von den
            benutzten Tools können Kundendaten wie Name, Adresse, Telefonnummer
            und IP-Adresse versandt werden.
          </p>
          <p>
            Facebook verwendet diese Informationen, um die Daten mit den Daten,
            die es selbst von Ihnen hat (sofern Sie Facebook-Mitglied sind)
            abzugleichen. Bevor Kundendaten an Facebook übermittelt werden,
            erfolgt ein sogenanntes „Hashing“. Das bedeutet, dass ein beliebig
            großer Datensatz in eine Zeichenkette transformiert wird. Dies dient
            auch der Verschlüsselung von Daten.
          </p>
          <p>
            Neben den Kontaktdaten werden auch „Event-Daten“ übermittelt. Unter
            „Event-Daten“ sind jene Informationen gemeint, die wir über Sie auf
            unserer Webseite erhalten. Zum Beispiel, welche Unterseiten Sie
            besuchen oder welche Produkte Sie bei uns kaufen. Facebook teilt die
            erhaltenen Informationen nicht mit Drittanbietern (wie
            beispielsweise Werbetreibende), außer das Unternehmen hat eine
            explizite Genehmigung oder ist rechtlich dazu verpflichtet.
            „Event-Daten“ können auch mit Kontaktdaten verbunden werden. Dadurch
            kann Facebook bessere personalisierte Werbung anbieten. Nach dem
            bereits erwähnten Abgleichungsprozess löscht Facebook die
            Kontaktdaten wieder.
          </p>
          <p>
            Um Werbeanzeigen optimiert ausliefern zu können, verwendet Facebook
            die Event-Daten nur, wenn diese mit anderen Daten (die auf andere
            Weise von Facebook erfasst wurden) zusammengefasst wurden. Diese
            Event-Daten nützt Facebook auch für Sicherheits-, Schutz-,
            Entwicklungs- und Forschungszwecke. Viele dieser Daten werden über
            Cookies zu Facebook übertragen. Cookies sind kleine Text-Dateien,
            die zum Speichern von Daten bzw. Informationen in Browsern verwendet
            werden. Je nach verwendeten Tools und abhängig davon, ob Sie
            Facebook-Mitglied sind, werden unterschiedlich viele Cookies in
            Ihrem Browser angelegt. In den Beschreibungen der einzelnen Facebook
            Tools gehen wir näher auf einzelne Facebook-Cookies ein. Allgemeine
            Informationen über die Verwendung von Facebook-Cookies erfahren Sie
            auch auf{" "}
            <a
              className="adsimple-111742326"
              href="https://www.facebook.com/policies/cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://www.facebook.com/policies/cookies
            </a>
            .
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie lange und wo werden die Daten gespeichert?
          </h3>
          <p>
            Grundsätzlich speichert Facebook Daten bis sie nicht mehr für die
            eigenen Dienste und Facebook-Produkte benötigt werden. Facebook hat
            auf der ganzen Welt Server verteilt, wo seine Daten gespeichert
            werden. Kundendaten werden allerdings, nachdem sie mit den eigenen
            Userdaten abgeglichen wurden, innerhalb von 48 Stunden gelöscht.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung
            verhindern?
          </h3>
          <p>
            Entsprechend der Datenschutz Grundverordnung haben Sie das Recht auf
            Auskunft, Berichtigung, Übertragbarkeit und Löschung Ihrer Daten.
          </p>
          <p>
            Eine komplette Löschung der Daten erfolgt nur, wenn Sie Ihr
            Facebook-Konto vollständig löschen. Und so funktioniert das Löschen
            Ihres Facebook-Kontos:
          </p>
          <p>1) Klicken Sie rechts bei Facebook auf Einstellungen.</p>
          <p>
            2) Anschließend klicken Sie in der linken Spalte auf „Deine
            Facebook-Informationen“.
          </p>
          <p>3) Nun klicken Sie “Deaktivierung und Löschung”.</p>
          <p>
            4) Wählen Sie jetzt „Konto löschen“ und klicken Sie dann auf „Weiter
            und Konto löschen“
          </p>
          <p>
            5) Geben Sie nun Ihr Passwort ein, klicken Sie auf „Weiter“ und dann
            auf „Konto löschen“
          </p>
          <p>
            Die Speicherung der Daten, die Facebook über unsere Seite erhält,
            erfolgt unter anderem über Cookies (z.B. bei sozialen Plugins). In
            Ihrem Browser können Sie einzelne oder alle Cookies deaktivieren,
            löschen oder verwalten. Je nach dem welchen Browser Sie verwenden,
            funktioniert dies auf unterschiedliche Art und Weise. Die folgenden
            Anleitungen zeigen, wie Sie Cookies in Ihrem Browser verwalten:
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.google.com/chrome/answer/95647?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren
            Browser so einrichten, dass er Sie immer informiert, wenn ein Cookie
            gesetzt werden soll. So können Sie bei jedem einzelnen Cookie
            entscheiden, ob Sie es erlauben oder nicht.
          </p>
          <p>
            Bitte beachten Sie, dass bei der Verwendung dieses Tools Daten von
            Ihnen auch außerhalb der EU gespeichert und verarbeitet werden
            können. Die meisten Drittstaaten (darunter auch die USA) gelten nach
            derzeitigem europäischen Datenschutzrecht als nicht sicher. Daten an
            unsichere Drittstaaten dürfen also nicht einfach übertragen, dort
            gespeichert und verarbeitet werden, sofern es keine passenden
            Garantien (wie etwa EU-Standardvertragsklauseln) zwischen uns und
            dem außereuropäischen Dienstleister gibt.
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
            Social-Media-Elemente verarbeitet und gespeichert werden können,
            gilt diese Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
            <strong className="adsimple-111742326">
              (Art. 6 Abs. 1 lit. a DSGVO)
            </strong>
            . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres
            berechtigten Interesses{" "}
            <strong className="adsimple-111742326">
              (Art. 6 Abs. 1 lit. f DSGVO)
            </strong>{" "}
            an einer schnellen und guten Kommunikation mit Ihnen oder anderen
            Kunden und Geschäftspartnern gespeichert und verarbeitet. Die
            meisten Social-Media-Plattformen setzen auch Cookies in Ihrem
            Browser, um Daten zu speichern. Darum empfehlen wir Ihnen, unseren
            Datenschutztext über Cookies genau durchzulesen und die
            Datenschutzerklärung oder die Cookie-Richtlinien des jeweiligen
            Dienstanbieters anzusehen.
          </p>
          <p>
            Wir hoffen wir haben Ihnen die wichtigsten Informationen über die
            Nutzung und Datenverarbeitung durch die Facebook-Tools
            nähergebracht. Wenn Sie mehr darüber erfahren wollen, wie Facebook
            Ihre Daten verwendet, empfehlen wir Ihnen die Datenrichtlinien auf{" "}
            <a
              className="adsimple-111742326"
              href="https://www.facebook.com/about/privacy/update"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://www.facebook.com/about/privacy/update
            </a>
            .
          </p>
          <br /><h2
            id="facebook-soziale-plug-ins-datenschutzerklaerung"
            className="adsimple-111742326"
          >
            Facebook Soziale Plug-ins Datenschutzerklärung
          </h2>
          <p>
            Auf unserer Webseite sind sogenannte soziale Plug-ins des
            Unternehmens Facebook Inc. eingebaut. Sie erkennen diese Buttons am
            klassischen Facebook-Logo, wie dem „Gefällt mir“-Button (die Hand
            mit erhobenem Daumen) oder an einer eindeutigen „Facebook
            Plug-in“-Kennzeichnung. Ein soziales Plug-in ist ein kleiner Teil
            von Facebook, der in unsere Seite integriert ist. Jedes Plug-in hat
            eine eigene Funktion. Die am meisten verwendeten Funktionen sind die
            bekannten “Gefällt mir”- und “Teilen”-Buttons.
          </p>
          <p>Folgende soziale Plug-ins werden von Facebook angeboten:</p>
          <ul className="adsimple-111742326">
            <li className="adsimple-111742326">“Speichern”-Button</li>
            <li className="adsimple-111742326">
              “Gefällt mir”-Button, Teilen, Senden und Zitat
            </li>
            <li className="adsimple-111742326">Seiten-Plug-in</li>
            <li className="adsimple-111742326">Kommentare</li>
            <li className="adsimple-111742326">Messenger-Plug-in</li>
            <li className="adsimple-111742326">
              Eingebettete Beiträge und Videoplayer
            </li>
            <li className="adsimple-111742326">Gruppen-Plug-in</li>
          </ul>
          <p>
            Auf{" "}
            <a
              className="adsimple-111742326"
              href="https://developers.facebook.com/docs/plugins"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://developers.facebook.com/docs/plugins
            </a>{" "}
            erhalten Sie nähere Informationen, wie die einzelnen Plug-ins
            verwendet werden. Wir nützen die sozialen Plug-ins einerseits, um
            Ihnen ein besseres Usererlebnis auf unserer Seite zu bieten,
            andererseits weil Facebook dadurch unsere Werbeanzeigen optimieren
            kann.
          </p>
          <p>
            Sofern Sie ein Facebook-Konto haben oder{" "}
            <a
              className="adsimple-111742326"
              href="https://www.facebook.com/"
              target="_blank"
              rel="follow noreferrer noreferrer"
            >
              facebook.com
            </a>{" "}
            schon mal besucht haben, hat Facebook bereits mindestens ein Cookie
            in Ihrem Browser gesetzt. In diesem Fall sendet Ihr Browser über
            dieses Cookie Informationen an Facebook, sobald Sie unsere Seite
            besuchen bzw. mit sozialen Plug-ins (z.B. dem „Gefällt mir“-Button)
            interagieren.
          </p>
          <p>
            Die erhaltenen Informationen werden innerhalb von 90 Tagen wieder
            gelöscht bzw. anonymisiert. Laut Facebook gehören zu diesen Daten
            Ihre IP-Adresse, welche Webseite Sie besucht haben, das Datum, die
            Uhrzeit und weitere Informationen, die Ihren Browser betreffen.
          </p>
          <p>
            Um zu verhindern, dass Facebook während Ihres Besuches auf unserer
            Webseite viele Daten sammelt und mit den Facebook-Daten verbindet,
            müssen Sie sich während des Webseitenbesuchs von Facebook abmelden
            (ausloggen).
          </p>
          <p>
            Falls Sie bei Facebook nicht angemeldet sind oder kein
            Facebook-Konto besitzen, sendet Ihr Browser weniger Informationen an
            Facebook, weil Sie weniger Facebook-Cookies haben. Dennoch können
            Daten wie beispielsweise Ihre IP-Adresse oder welche Webseite Sie
            besuchen an Facebook übertragen werden. Wir möchten noch
            ausdrücklich darauf hinweisen, dass wir über die genauen Inhalte der
            Daten nicht exakt Bescheid wissen. Wir versuchen aber Sie nach
            unserem aktuellen Kenntnisstand so gut als möglich über die
            Datenverarbeitung aufzuklären. Wie Facebook die Daten nutzt, können
            Sie auch in den Datenrichtline des Unternehmens unter{" "}
            <a
              className="adsimple-111742326"
              href="https://www.facebook.com/about/privacy/update"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://www.facebook.com/about/privacy/update
            </a>{" "}
            nachlesen.
          </p>
          <p>
            Folgende Cookies werden in Ihrem Browser mindestens gesetzt, wenn
            Sie eine Webseite mit sozialen Plug-ins von Facebook besuchen:
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> dpr
            <br />
            <strong className="adsimple-111742326">Wert:</strong> keine Angabe
            <br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            Dieses Cookie wird verwendet, damit die sozialen Plug-ins auf
            unserer Webseite funktionieren.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach
            Sitzungsende
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> fr
            <br />
            <strong className="adsimple-111742326">Wert:</strong>{" "}
            0jieyh4111742326c2GnlufEJ9..Bde09j…1.0.Bde09j
            <br />
            <strong className="adsimple-111742326">Verwendungszweck:</strong>
             Auch das Cookie ist nötig, dass die Plug-ins einwandfrei
            funktionieren.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum::</strong> nach 3
            Monaten
          </p>
          <p>
            <strong className="adsimple-111742326">Anmerkung:</strong> Diese
            Cookies wurden nach einem Test gesetzt, auch wenn Sie nicht
            Facebook-Mitglied sind.
          </p>
          <p>
            Sofern Sie bei Facebook angemeldet sind, können Sie Ihre
            Einstellungen für Werbeanzeigen unter{" "}
            <a
              className="adsimple-111742326"
              href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen
            </a>
             selbst verändern. Falls Sie kein Facebook-User sind, können Sie auf{" "}
            <a
              className="adsimple-111742326"
              href="http://www.youronlinechoices.com/de/praferenzmanagement/?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              http://www.youronlinechoices.com/de/praferenzmanagement/
            </a>
            grundsätzlich Ihre nutzungsbasierte Online-Werbung verwalten. Dort
            haben Sie die Möglichkeit, Anbieter zu deaktivieren bzw. zu
            aktivieren.
          </p>
          <p>
            Wenn Sie mehr über den Datenschutz von Facebook erfahren wollen,
            empfehlen wir Ihnen die eigenen Datenrichtlinien des Unternehmens
            auf{" "}
            <a
              className="adsimple-111742326"
              href="https://www.facebook.com/policy.php?tip=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://www.facebook.com/policy.php
            </a>
            .
          </p>
          <br /><h2 id="twitter-datenschutzerklaerung" className="adsimple-111742326">
            Twitter Datenschutzerklärung
          </h2>
          <table border="1" cellpadding="15">
            <tbody>
              <tr>
                <td>
                  <strong className="adsimple-111742326">
                  <div className={styles.boxTitle}>Twitter Datenschutzerklärung Zusammenfassung</div>
                  </strong>
                  <br /><div className={styles.box}>
                  👥 Betroffene: Besucher der Website
                  <br />
                  🤝 Zweck: Optimierung unserer Serviceleistung
                  <br />
                  📓 Verarbeitete Daten: Daten wie etwa Daten zum
                  Nutzerverhalten, Informationen zu Ihrem Gerät und Ihre
                  IP-Adresse.
                  <br />
                  Mehr Details dazu finden Sie weiter unten in der
                  Datenschutzerklärung.
                  <br />
                  📅 Speicherdauer: erhobene Daten von anderen Website löscht
                  Twitter nach spätestens 30 Tagen
                  <br />
                  ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO
                  (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                  Interessen)
              </div>  </td>
              </tr>
            </tbody>
          </table>
          <br /><h3 className="adsimple-111742326">Was ist Twitter?</h3>
          <p>
            Auf unserer Website haben wir Funktionen von Twitter eingebaut.
            Dabei handelt es sich zum Beispiel um eingebettete Tweets,
            Timelines, Buttons oder Hashtags. Twitter ist ein
            Kurznachrichtendienst und eine Social-Media-Plattform der Firma
            Twitter Inc., One Cumberland Place, Fenian Street, Dublin 2 D02
            AX07, Irland.
          </p>
          <p>
            Nach unserer Kenntnis werden im Europäischen Wirtschaftsraum und in
            der Schweiz durch das bloße Einbinden von Twitter-Funktion noch
            keine personenbezogenen Daten oder Daten zu Ihrer Webaktivitäten an
            Twitter übertragen. Erst wenn Sie mit den Twitter-Funktionen
            interagieren, wie zum Beispiel auf einen Button klicken, können
            Daten an Twitter gesendet, dort gespeichert und verarbeitet werden.
            Auf diese Datenverarbeitung haben wir keinen Einfluss und tragen
            keine Verantwortung. Im Rahmen dieser Datenschutzerklärung wollen
            wir Ihnen einen Überblick geben, welche Daten Twitter speichert, was
            Twitter mit diesen Daten macht und wie Sie sich vor der
            Datenübertragung weitgehend schützen können.
          </p>
          <p>
            Für die einen ist Twitter ein Nachrichtendienst, für andere eine
            Social-Media-Plattform und wieder andere sprechen von einem
            Microblogging-Dienst. All diese Bezeichnungen haben ihre
            Berechtigung und meinen mehr oder weniger dasselbe.
          </p>
          <p>
            Sowohl Privatpersonen als auch Unternehmen nützen Twitter, um mit
            interessierten Personen über Kurznachrichten zu kommunizieren. Pro
            Nachricht erlaubt Twitter nur 280 Zeichen. Diese Nachrichten werden
            „Tweets“ genannt. Anders als beispielsweise bei Facebook fokussiert
            sich der Dienst nicht auf den Ausbau eines Netzwerks für “Freunde”,
            sondern will als weltweite und offene Nachrichten-Plattform
            verstanden werden. Bei Twitter kann man auch ein anonymes Konto
            führen und Tweets können einerseits vom Unternehmen, andererseits
            von den Usern selbst gelöscht werden.
          </p>
          <br /><h3 className="adsimple-111742326">
            Warum verwenden wir Twitter auf unserer Website?
          </h3>
          <p>
            Wie viele andere Webseiten und Unternehmen versuchen wir unsere
            Services und Dienstleistungen über verschiedene Kanäle anzubieten
            und mit unseren Kunden zu kommunizieren. Speziell Twitter ist uns
            als nützlicher „kleiner“ Nachrichtendienst ans Herz gewachsen. Immer
            wieder tweeten oder retweeten wir spannende, lustige oder
            interessante Inhalte. Uns ist klar, dass Sie nicht jedem Kanal extra
            folgen können. Schließlich haben Sie auch noch etwas anderes zu tun.
            Darum haben wir auf unserer Webseite auch Twitter-Funktionen
            eingebunden. Sie können unsere Twitter-Aktivität „vor Ort“
            miterleben oder über einen direkten Link zu unserer Twitter-Seite
            kommen. Durch die Einbindung wollen wir unser Service und die
            Nutzerfreundlichkeit auf unserer Webseite stärken.
          </p>
          <br /><h3 className="adsimple-111742326">
            Welche Daten werden von Twitter gespeichert?
          </h3>
          <p>
            Auf manchen unserer Unterseiten finden Sie die eingebauten
            Twitter-Funktionen. Wenn Sie mit den Twitter-Inhalten interagieren,
            wie zum Beispiel auf einen Button klicken, kann Twitter Daten
            erfassen und speichern. Und zwar auch dann, wenn Sie selbst kein
            Twitter-Konto haben. Twitter nennt diese Daten “Log-Daten”. Dazu
            zählen demografische Daten, Browser-Cookie-IDs, die ID Ihres
            Smartphones, gehashte E-Mail-Adressen, und Informationen, welche
            Seiten Sie bei Twitter besucht haben und welche Handlungen Sie
            ausgeführt haben. Twitter speichert natürlich mehr Daten, wenn Sie
            ein Twitter-Konto haben und angemeldet sind. Meistens passiert diese
            Speicherung über Cookies. Cookies sind kleine Text-Dateien, die
            meist in Ihrem Browser gesetzt werden und unterschiedliche
            Information an Twitter übermitteln.
          </p>
          <p>
            Welche Cookies gesetzt werden, wenn Sie nicht bei Twitter angemeldet
            sind, aber eine Webseite mit eingebauten Twitter-Funktionen
            besuchen, zeigen wir Ihnen jetzt. Bitte betrachten Sie diese
            Aufzählung als Beispiel. Einen Anspruch auf Vollständigkeit können
            wir hier auf keinen Fall gewährleisten, da sich die Wahl der Cookies
            stets verändert und von Ihren individuellen Handlungen mit den
            Twitter-Inhalten abhängt.
          </p>
          <p>Diese Cookies wurden bei unserem Test verwendet:</p>
          <p>
            <strong className="adsimple-111742326">Name:</strong>{" "}
            personalization_id
            <br />
            <strong className="adsimple-111742326">Wert:</strong>{" "}
            “v1_cSJIsogU51SeE111742326”
            <br />
            <strong className="adsimple-111742326">Verwendungszweck: </strong>
            Dieses Cookie speichert Informationen darüber, wie Sie die Webseite
            nutzen und über welche Werbung Sie möglicherweise zu Twitter
            gekommen sind.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 2
            Jahren
          </p>
          <p>
            <strong className="adsimple-111742326">Name: </strong>lang
            <br />
            <strong className="adsimple-111742326">Wert: </strong>de
            <br />
            <strong className="adsimple-111742326">Verwendungszweck: </strong>
            Dieses Cookie speichert Ihre voreingestellte bzw. bevorzugte
            Sprache.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum: </strong>nach
            Sitzungsende
          </p>
          <p>
            <strong className="adsimple-111742326">Name: </strong>guest_id
            <br />
            <strong className="adsimple-111742326">Wert: </strong>
            111742326v1%3A157132626
            <br />
            <strong className="adsimple-111742326">Verwendungszweck: </strong>
            Dieses Cookie wird gesetzt, um Sie als Gast zu identifizieren.
            <strong className="adsimple-111742326"> </strong>
            <br />
            <strong className="adsimple-111742326">Ablaufdatum: </strong>nach 2
            Jahren
          </p>
          <p>
            <strong className="adsimple-111742326">Name: </strong>fm
            <br />
            <strong className="adsimple-111742326">Wert: </strong>0<br />
            <strong className="adsimple-111742326">Verwendungszweck: </strong>Zu
            diesem Cookie konnten wir leider den Verwendungszweck nicht in
            Erfahrung bringen.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum: </strong>nach
            Sitzungsende
          </p>
          <p>
            <strong className="adsimple-111742326">Name: </strong>
            external_referer
            <br />
            <strong className="adsimple-111742326">Wert: </strong>
            1117423262beTA0sf5lkMrlGt
            <br />
            <strong className="adsimple-111742326">Verwendungszweck: </strong>
            Dieses Cookie sammelt anonyme Daten, wie zum Beispiel wie oft Sie
            Twitter besuchen und wie lange Sie Twitter besuchen.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum: </strong>Nach 6
            Tagen
          </p>
          <p>
            <strong className="adsimple-111742326">Name: </strong>eu_cn
            <br />
            <strong className="adsimple-111742326">Wert: </strong>1<br />
            <strong className="adsimple-111742326">Verwendungszweck: </strong>
            Dieses Cookie speichert Useraktivität und dient diversen
            Werbezwecken von Twitter.{" "}
            <strong className="adsimple-111742326">
              <br />
              Ablaufdatum:{" "}
            </strong>
            Nach einem Jahr
          </p>
          <p>
            <strong className="adsimple-111742326">Name: </strong>ct0
            <br />
            <strong className="adsimple-111742326">Wert: </strong>
            c1179f07163a365d2ed7aad84c99d966
            <br />
            <strong className="adsimple-111742326">Verwendungszweck: </strong>Zu
            diesem Cookie haben wir leider keine Informationen gefunden.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum: </strong>nach 6
            Stunden
          </p>
          <p>
            <strong className="adsimple-111742326">Name: </strong>_twitter_sess
            <br />
            <strong className="adsimple-111742326">Wert: </strong>
            53D%253D–dd0248111742326-
            <br />
            <strong className="adsimple-111742326">Verwendungszweck: </strong>
            Mit diesem Cookie können Sie Funktionen innerhalb der
            Twitter-Webseite nutzen.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum: </strong>nach
            Sitzungsende
          </p>
          <p>
            <strong className="adsimple-111742326">Anmerkung:</strong> Twitter
            arbeitet auch mit Drittanbietern zusammen. Darum haben wir bei
            unserem Test auch die drei Google-Analytics-Cookies _ga, _gat, _gid
            erkannt.
          </p>
          <p>
            Twitter verwendet die erhobenen Daten einerseits, um das
            Userverhalten besser zu verstehen und somit seine eigenen Dienste
            und Werbeangebote zu verbessern, andererseits dienen die Daten auch
            internen Sicherheitsmaßnahmen.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie lange und wo werden die Daten gespeichert?
          </h3>
          <p>
            Wenn Twitter Daten von anderen Websites erhebt, werden diese nach
            maximal 30 Tagen gelöscht, zusammengefasst oder auf andere Weise
            verdeckt. Die Twitter-Server liegen auf verschiedenen Serverzentren
            in den Vereinigten Staaten. Demnach ist davon auszugehen, dass die
            erhobenen Daten in Amerika gesammelt und gespeichert werden. Nach
            unserer Recherche konnten wir nicht eindeutig feststellen, ob
            Twitter auch eigene Server in Europa hat. Grundsätzlich kann Twitter
            die erhobenen Daten speichern, bis sie dem Unternehmen nicht mehr
            dienlich sind, Sie die Daten löschen oder eine gesetzliche
            Löschfrist besteht.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung
            verhindern?
          </h3>
          <p>
            Twitter betont in seinen Datenschutzrichtlinien immer wieder, dass
            es keine Daten von externen Webseitenbesuchen speichert, wenn Sie
            bzw. Ihr Browser sich im europäischen Wirtschaftsraum oder in der
            Schweiz befinden. Falls Sie allerdings mit Twitter direkt
            interagieren, speichert Twitter selbstverständlich auch Daten von
            Ihnen.
          </p>
          <p>
            Wenn Sie ein Twitter-Konto besitzen, können Sie Ihre Daten
            verwalten, indem Sie unter dem „Profil“-Button auf „Mehr“ klicken.
            Anschließend klicken Sie auf „Einstellungen und Datenschutz“. Hier
            können Sie die Datenverarbeitung individuell verwalten.
          </p>
          <p>
            Wenn Sie kein Twitter-Konto besitzen, können Sie auf{" "}
            <a className="adsimple-111742326" href="https://twitter.com/">
              twitter.com
            </a>
             gehen und dann auf „Individualisierung“ klicken. Unter dem Punkt
            „Individualisierung und Daten“ können Sie Ihre erhobenen Daten
            verwalten.
          </p>
          <p>
            Die meisten Daten werden, wie oben bereits erwähnt, über Cookies
            gespeichert und die können Sie in Ihrem Browser verwalten,
            deaktivieren oder löschen. Bitte beachten Sie, dass Sie die Cookies
            nur in dem von Ihnen gewählten Browser “bearbeiten”. Das heißt:
            verwenden Sie in Zukunft einen anderen Browser, müssen Sie dort Ihre
            Cookies erneut nach Ihren Wünschen verwalten. Hier gibt es die
            Anleitung zur Cookie-Verwaltung der bekanntesten Browser.
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.google.com/chrome/answer/95647?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Ihren Browser können Sie auch so verwalten, dass Sie bei jedem
            einzelnen Cookie informiert werden. Dann können Sie immer
            individuell entscheiden, ob Sie ein Cookie zulassen oder nicht.
          </p>
          <p>
            Twitter verwendet die Daten auch für personalisierte Werbung in- und
            außerhalb von Twitter. In den Einstellungen können Sie unter
            „Individualisierung und Daten“ die personalisierte Werbung
            abschalten. Wenn Sie Twitter auf einem Browser nutzen, können Sie
            die personalisierte Werbung unter{" "}
            <a
              className="adsimple-111742326"
              href="http://optout.aboutads.info/?c=2&lang=EN"
              target="_blank"
              rel="follow noreferrer noreferrer"
            >
              http://optout.aboutads.info/?c=2&lang=EN
            </a>{" "}
            deaktivieren.
          </p>
          <p>
            Bitte beachten Sie, dass bei der Verwendung dieses Tools Daten von
            Ihnen auch außerhalb der EU gespeichert und verarbeitet werden
            können. Die meisten Drittstaaten (darunter auch die USA) gelten nach
            derzeitigem europäischen Datenschutzrecht als nicht sicher. Daten an
            unsichere Drittstaaten dürfen also nicht einfach übertragen, dort
            gespeichert und verarbeitet werden, sofern es keine passenden
            Garantien (wie etwa EU-Standardvertragsklauseln) zwischen uns und
            dem außereuropäischen Dienstleister gibt.
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Wenn Sie eingewilligt haben, dass Daten von Ihnen durch eingebundene
            Social-Media-Elemente verarbeitet und gespeichert werden können,
            gilt diese Einwilligung als Rechtsgrundlage der Datenverarbeitung{" "}
            <strong className="adsimple-111742326">
              (Art. 6 Abs. 1 lit. a DSGVO)
            </strong>
            . Grundsätzlich werden Ihre Daten auch auf Grundlage unseres
            berechtigten Interesses{" "}
            <strong className="adsimple-111742326">
              (Art. 6 Abs. 1 lit. f DSGVO)
            </strong>{" "}
            an einer schnellen und guten Kommunikation mit Ihnen oder anderen
            Kunden und Geschäftspartnern gespeichert und verarbeitet. Die
            meisten Social-Media-Plattformen setzen auch Cookies in Ihrem
            Browser, um Daten zu speichern. Darum empfehlen wir Ihnen, unseren
            Datenschutztext über Cookies genau durchzulesen und die
            Datenschutzerklärung oder die Cookie-Richtlinien des jeweiligen
            Dienstanbieters anzusehen.
          </p>
          <p>
            Wir hoffen, wir haben Ihnen einen grundsätzlichen Überblick über die
            Datenverarbeitung durch Twitter gegeben. Wir erhalten keinen Daten
            von Twitter und tragen auch keine Verantwortung darüber, was Twitter
            mit Ihren Daten macht. Falls Sie noch weitere Fragen zu diesem Thema
            haben, empfehlen wir Ihnen die Twitter-Datenschutzerklärung unter{" "}
            <a
              className="adsimple-111742326"
              href="https://twitter.com/de/privacy"
            >
              https://twitter.com/de/privacy
            </a>
            .
          </p>
          <br /><h2
            id="google-maps-datenschutzerklaerung"
            className="adsimple-111742326"
          >
            Google Maps Datenschutzerklärung
          </h2>
          <table border="1" cellpadding="15">
            <tbody>
              <tr>
                <td>
                  <strong className="adsimple-111742326">
                  <div className={styles.boxTitle}>Google Maps Datenschutzerklärung Zusammenfassung
                 </div> </strong>
                  <br /><div className={styles.box}>
                  👥 Betroffene: Besucher der Website
                  <br />
                  🤝 Zweck: Optimierung unserer Serviceleistung
                  <br />
                  📓 Verarbeitete Daten: Daten wie etwa eingegebene
                  Suchbegriffe, Ihre IP-Adresse und auch die Breiten- bzw.
                  Längenkoordinaten.
                  <br />
                  Mehr Details dazu finden Sie weiter unten in dieser
                  Datenschutzerklärung.
                  <br />
                  📅 Speicherdauer: abhängig von den gespeicherten Daten
                  <br />
                  ⚖️ Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO
                  (Einwilligung), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                  Interessen)
                </div></td>
              </tr>
            </tbody>
          </table>
          <br /><h3 className="adsimple-111742326">Was ist Google Maps?</h3>
          <p>
            Wir benützen auf unserer Website Google Maps der Firma Google Inc.
            Für den europäischen Raum ist das Unternehmen Google Ireland Limited
            (Gordon House, Barrow Street Dublin 4, Irland) für alle
            Google-Dienste verantwortlich. Mit Google Maps können wir Ihnen
            Standorte besser zeigen und damit unser Service an Ihre Bedürfnisse
            anpassen. Durch die Verwendung von Google Maps werden Daten an
            Google übertragen und auf den Google-Servern gespeichert. Hier
            wollen wir nun genauer darauf eingehen, was Google Maps ist, warum
            wir diesen Google-Dienst in Anspruch nehmen, welche Daten
            gespeichert werden und wie Sie dies unterbinden können.
          </p>
          <p>
            Google Maps ist ein Internet-Kartendienst der Firma Google. Mit
            Google Maps können Sie online über einen PC, ein Tablet oder eine
            App genaue Standorte von Städten, Sehenswürdigkeiten, Unterkünften
            oder Unternehmen suchen. Wenn Unternehmen auf Google My Business
            vertreten sind, werden neben dem Standort noch weitere Informationen
            über die Firma angezeigt. Um die Anfahrtsmöglichkeit anzuzeigen,
            können Kartenausschnitte eines Standorts mittels HTML-Code in eine
            Website eingebunden werden. Google Maps zeigt die Erdoberfläche als
            Straßenkarte oder als Luft- bzw. Satellitenbild. Dank der Street
            View Bilder und den hochwertigen Satellitenbildern sind sehr genaue
            Darstellungen möglich.
          </p>
          <br /><h3 className="adsimple-111742326">
            Warum verwenden wir Google Maps auf unserer Website?
          </h3>
          <p>
            All unsere Bemühungen auf dieser Seite verfolgen das Ziel, Ihnen
            eine nützliche und sinnvolle Zeit auf unserer Webseite zu bieten.
            Durch die Einbindung von Google Maps können wir Ihnen die
            wichtigsten Informationen zu diversen Standorten liefern. Sie sehen
            auf einen Blick wo wir unseren Firmensitz haben. Die Wegbeschreibung
            zeigt Ihnen immer den besten bzw. schnellsten Weg zu uns. Sie können
            den Anfahrtsweg für Routen mit dem Auto, mit öffentlichen
            Verkehrsmitteln, zu Fuß oder mit dem Fahrrad abrufen. Für uns ist
            die Bereitstellung von Google Maps Teil unseres Kundenservice.
          </p>
          <br /><h3 className="adsimple-111742326">
            Welche Daten werden von Google Maps gespeichert?
          </h3>
          <p>
            Damit Google Maps ihren Dienst vollständig anbieten kann, muss das
            Unternehmen Daten von Ihnen aufnehmen und speichern. Dazu zählen
            unter anderem die eingegebenen Suchbegriffe, Ihre IP-Adresse und
            auch die Breiten- bzw. Längenkoordinaten. Benutzen Sie die
            Routenplaner-Funktion wird auch die eingegebene Startadresse
            gespeichert. Diese Datenspeicherung passiert allerdings auf den
            Webseiten von Google Maps. Wir können Sie darüber nur informieren,
            aber keinen Einfluss nehmen. Da wir Google Maps in unsere Webseite
            eingebunden haben, setzt Google mindestens ein Cookie (Name: NID) in
            Ihrem Browser. Dieses Cookie speichert Daten über Ihr Userverhalten.
            Google nutzt diese Daten in erster Linie, um eigene Dienste zu
            optimieren und individuelle, personalisierte Werbung für Sie
            bereitzustellen.
          </p>
          <p>
            Folgendes Cookie wird aufgrund der Einbindung von Google Maps in
            Ihrem Browser gesetzt:
          </p>
          <p>
            <strong className="adsimple-111742326">Name:</strong> NID
            <br />
            <strong className="adsimple-111742326">Wert:</strong>{" "}
            188=h26c1Ktha7fCQTx8rXgLyATyITJ111742326-5
            <br />
            <strong className="adsimple-111742326">
              Verwendungszweck:
            </strong>{" "}
            NID wird von Google verwendet, um Werbeanzeigen an Ihre Google-Suche
            anzupassen. Mit Hilfe des Cookies „erinnert“ sich Google an Ihre am
            häufigsten eingegebenen Suchanfragen oder Ihre frühere Interaktion
            mit Anzeigen. So bekommen Sie immer maßgeschneiderte Werbeanzeigen.
            Das Cookie enthält eine einzigartige ID, die Google benutzt, um Ihre
            persönlichen Einstellungen für Werbezwecke zu sammeln.
            <br />
            <strong className="adsimple-111742326">Ablaufdatum:</strong> nach 6
            Monaten
          </p>
          <p>
            <strong className="adsimple-111742326">Anmerkung:</strong> Wir
            können bei den Angaben der gespeicherten Daten keine Vollständigkeit
            gewährleisten. Speziell bei der Verwendung von Cookies sind
            Veränderungen nie auszuschließen. Um das Cookie NID zu
            identifizieren, wurde eine eigene Testseite angelegt, wo
            ausschließlich Google Maps eingebunden war.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie lange und wo werden die Daten gespeichert?
          </h3>
          <p>
            Die Google-Server stehen in Rechenzentren auf der ganzen Welt. Die
            meisten Server befinden sich allerdings in Amerika. Aus diesem Grund
            werden Ihre Daten auch vermehrt in den USA gespeichert. Hier können
            Sie genau nachlesen wo sich die Google-Rechenzentren befinden:{" "}
            <a
              className="adsimple-111742326"
              href="https://www.google.com/about/datacenters/inside/locations/?hl=de"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://www.google.com/about/datacenters/inside/locations/?hl=de
            </a>
          </p>
          <p>
            Die Daten verteilt Google auf verschiedenen Datenträgern. Dadurch
            sind die Daten schneller abrufbar und werden vor etwaigen
            Manipulationsversuchen besser geschützt. Jedes Rechenzentrum hat
            auch spezielle Notfallprogramme. Wenn es zum Beispiel Probleme bei
            der Google-Hardware gibt oder eine Naturkatastrophe die Server lahm
            legt, bleiben die Daten ziemlich sicher trotzdem geschützt.
          </p>
          <p>
            Manche Daten speichert Google für einen festgelegten Zeitraum. Bei
            anderen Daten bietet Google lediglich die Möglichkeit, diese manuell
            zu löschen. Weiters anonymisiert das Unternehmen auch Informationen
            (wie zum Beispiel Werbedaten) in Serverprotokollen, indem es einen
            Teil der IP-Adresse und Cookie-Informationen nach 9 bzw.18 Monaten
            löscht.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung
            verhindern?
          </h3>
          <p>
            Mit der 2019 eingeführten automatischen Löschfunktion von Standort-
            und Aktivitätsdaten werden Informationen zur Standortbestimmung und
            Web-/App-Aktivität – abhängig von Ihrer Entscheidung – entweder 3
            oder 18 Monate gespeichert und dann gelöscht. Zudem kann man diese
            Daten über das Google-Konto auch jederzeit manuell aus dem Verlauf
            löschen. Wenn Sie Ihre Standorterfassung vollständig verhindern
            wollen, müssen Sie im Google-Konto die Rubrik „Web- und
            App-Aktivität“ pausieren. Klicken Sie „Daten und Personalisierung“
            und dann auf die Option „Aktivitätseinstellung“. Hier können Sie die
            Aktivitäten ein- oder ausschalten.
          </p>
          <p>
            In Ihrem Browser können Sie weiters auch einzelne Cookies
            deaktivieren, löschen oder verwalten. Je nach dem welchen Browser
            Sie verwenden, funktioniert dies immer etwas anders. Die folgenden
            Anleitungen zeigen, wie Sie Cookies in Ihrem Browser verwalten:
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.google.com/chrome/answer/95647?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Chrome: Cookies in Chrome löschen, aktivieren und verwalten
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Safari: Verwalten von Cookies und Websitedaten mit Safari
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf
              Ihrem Computer abgelegt haben
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Internet Explorer: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            <a
              className="adsimple-111742326"
              href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              Microsoft Edge: Löschen und Verwalten von Cookies
            </a>
          </p>
          <p>
            Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren
            Browser so einrichten, dass er Sie immer informiert, wenn ein Cookie
            gesetzt werden soll. So können Sie bei jedem einzelnen Cookie
            entscheiden, ob Sie es erlauben oder nicht.
          </p>
          <p>
            Bitte beachten Sie, dass bei der Verwendung dieses Tools Daten von
            Ihnen auch außerhalb der EU gespeichert und verarbeitet werden
            können. Die meisten Drittstaaten (darunter auch die USA) gelten nach
            derzeitigem europäischen Datenschutzrecht als nicht sicher. Daten an
            unsichere Drittstaaten dürfen also nicht einfach übertragen, dort
            gespeichert und verarbeitet werden, sofern es keine passenden
            Garantien (wie etwa EU-Standardvertragsklauseln) zwischen uns und
            dem außereuropäischen Dienstleister gibt.
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Wenn Sie eingewilligt haben, dass Google Maps eingesetzt werden
            darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung
            diese Einwilligung. Diese Einwilligung stellt laut
            <strong className="adsimple-111742326">
              {" "}
              Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
            </strong>{" "}
            die Rechtsgrundlage für die Verarbeitung personenbezogener Daten,
            wie sie bei der Erfassung durch Google Maps vorkommen kann, dar.
          </p>
          <p>
            Von unserer Seite besteht zudem ein berechtigtes Interesse, Google
            Maps zu verwenden, um unser Online-Service zu optimieren. Die dafür
            entsprechende Rechtsgrundlage ist{" "}
            <strong className="adsimple-111742326">
              Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
            </strong>
            .
          </p>
          <p>
            Wenn Sie mehr über die Datenverarbeitung von Google erfahren wollen,
            empfehlen wir Ihnen die hauseigene Datenschutzerklärung des
            Unternehmens unter{" "}
            <a
              className="adsimple-111742326"
              href="https://policies.google.com/privacy?hl=de"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://policies.google.com/privacy?hl=de
            </a>
            .
          </p>
          <br /><h2
            id="google-fonts-lokal-datenschutzerklaerung"
            className="adsimple-111742326"
          >
            Google Fonts Lokal Datenschutzerklärung
          </h2>
          <p>
            Auf unserer Website nutzen wir Google Fonts der Firma Google Inc.
            Für den europäischen Raum ist das Unternehmen Google Ireland Limited
            (Gordon House, Barrow Street Dublin 4, Irland) verantwortlich. Wir
            haben die Google-Schriftarten lokal, d.h. auf unserem Webserver –
            nicht auf den Servern von Google – eingebunden. Dadurch gibt es
            keine Verbindung zu Google-Servern und somit auch keine
            Datenübertragung oder Speicherung.
          </p>
          <br /><h3 className="adsimple-111742326">Was sind Google Fonts?</h3>
          <p>
            Früher nannte man Google Fonts auch Google Web Fonts. Dabei handelt
            es sich um ein interaktives Verzeichnis mit über 800 Schriftarten,
            die{" "}
            <a
              className="adsimple-111742326"
              href="https://de.wikipedia.org/wiki/Google_LLC?tid=111742326"
            >
              Google
            </a>
             kostenlos bereitstellt. Mit Google Fonts könnte man Schriften
            nutzen, ohne sie auf den eigenen Server hochzuladen. Doch um
            diesbezüglich jede Informationsübertragung zu Google-Servern zu
            unterbinden, haben wir die Schriftarten auf unseren Server
            heruntergeladen. Auf diese Weise handeln wir datenschutzkonform und
            senden keine Daten an Google Fonts weiter.
          </p>
          <br /><h2
            id="google-fonts-datenschutzerklaerung"
            className="adsimple-111742326"
          >
            Google Fonts Datenschutzerklärung
          </h2>
          <p>
            Auf unserer Website verwenden wir Google Fonts. Das sind die
            “Google-Schriften” der Firma Google Inc. Für den europäischen Raum
            ist das Unternehmen Google Ireland Limited (Gordon House, Barrow
            Street Dublin 4, Irland) für alle Google-Dienste verantwortlich.
          </p>
          <p>
            Für die Verwendung von Google-Schriftarten müssen Sie sich nicht
            anmelden bzw. ein Passwort hinterlegen. Weiters werden auch keine
            Cookies in Ihrem Browser gespeichert. Die Dateien (CSS,
            Schriftarten/Fonts) werden über die Google-Domains
            fonts.googleapis.com und fonts.gstatic.com angefordert. Laut Google
            sind die Anfragen nach CSS und Schriften vollkommen getrennt von
            allen anderen Google-Diensten. Wenn Sie ein Google-Konto haben,
            brauchen Sie keine Sorge haben, dass Ihre Google-Kontodaten, während
            der Verwendung von Google Fonts, an Google übermittelt werden.
            Google erfasst die Nutzung von CSS (Cascading Style Sheets) und der
            verwendeten Schriftarten und speichert diese Daten sicher. Wie die
            Datenspeicherung genau aussieht, werden wir uns noch im Detail
            ansehen.
          </p>
          <br /><h3 className="adsimple-111742326">Was sind Google Fonts?</h3>
          <p>
            Google Fonts (früher Google Web Fonts) ist ein Verzeichnis mit über
            800 Schriftarten, die{" "}
            <a
              className="adsimple-111742326"
              href="https://de.wikipedia.org/wiki/Google_LLC?tid=111742326"
            >
              Google
            </a>
             Ihren Nutzern kostenlos zu Verfügung stellen.
          </p>
          <p>
            Viele dieser Schriftarten sind unter der SIL Open Font
            License veröffentlicht, während andere unter
            der Apache-Lizenz veröffentlicht wurden. Beides sind freie
            Software-Lizenzen.
          </p>
          <br /><h3 className="adsimple-111742326">
            Warum verwenden wir Google Fonts auf unserer Website?
          </h3>
          <p>
            Mit Google Fonts können wir auf der eigenen Webseite Schriften
            nutzen, und müssen sie nicht auf unserem eigenen Server hochladen.
            Google Fonts ist ein wichtiger Baustein, um die Qualität unserer
            Webseite hoch zu halten. Alle Google-Schriften sind automatisch für
            das Web optimiert und dies spart Datenvolumen und ist speziell für
            die Verwendung bei mobilen Endgeräten ein großer Vorteil. Wenn Sie
            unsere Seite besuchen, sorgt die niedrige Dateigröße für eine
            schnelle Ladezeit. Des Weiteren sind Google Fonts sichere Web Fonts.
            Unterschiedliche Bildsynthese-Systeme (Rendering) in verschiedenen
            Browsern, Betriebssystemen und mobilen Endgeräten können zu Fehlern
            führen. Solche Fehler können teilweise Texte bzw. ganze Webseiten
            optisch verzerren. Dank des schnellen Content Delivery Network (CDN)
            gibt es mit Google Fonts keine plattformübergreifenden Probleme.
            Google Fonts unterstützt alle gängigen Browser (Google
            Chrome, Mozilla Firefox, Apple Safari, Opera) und funktioniert
            zuverlässig auf den meisten modernen mobilen Betriebssystemen,
            einschließlich Android 2.2+ und iOS 4.2+ (iPhone, iPad, iPod). Wir
            verwenden die Google Fonts also, damit wir unser gesamtes
            Online-Service so schön und einheitlich wie möglich darstellen
            können.
          </p>
          <br /><h3 className="adsimple-111742326">
            Welche Daten werden von Google gespeichert?
          </h3>
          <p>
            Wenn Sie unsere Webseite besuchen, werden die Schriften über einen
            Google-Server nachgeladen. Durch diesen externen Aufruf werden Daten
            an die Google-Server übermittelt. So erkennt Google auch, dass Sie
            bzw. Ihre IP-Adresse unsere Webseite besucht. Die Google Fonts API
            wurde entwickelt, um Verwendung, Speicherung und Erfassung von
            Endnutzerdaten auf das zu reduzieren, was für eine ordentliche
            Bereitstellung von Schriften nötig ist. API steht übrigens für
            „Application Programming Interface“ und dient unter anderem als
            Datenübermittler im Softwarebereich.
          </p>
          <p>
            Google Fonts speichert CSS- und Schrift-Anfragen sicher bei Google
            und ist somit geschützt. Durch die gesammelten Nutzungszahlen kann
            Google feststellen, wie gut die einzelnen Schriften ankommen. Die
            Ergebnisse veröffentlicht Google auf internen Analyseseiten, wie
            beispielsweise Google Analytics. Zudem verwendet Google auch Daten
            des eigenen Web-Crawlers, um festzustellen, welche Webseiten
            Google-Schriften verwenden. Diese Daten werden in der
            BigQuery-Datenbank von Google Fonts veröffentlicht. Unternehmer und
            Entwickler nützen das Google-Webservice BigQuery, um große
            Datenmengen untersuchen und bewegen zu können.
          </p>
          <p>
            Zu bedenken gilt allerdings noch, dass durch jede Google Font
            Anfrage auch Informationen wie Spracheinstellungen, IP-Adresse,
            Version des Browsers, Bildschirmauflösung des Browsers und Name des
            Browsers automatisch an die Google-Server übertragen werden. Ob
            diese Daten auch gespeichert werden, ist nicht klar feststellbar
            bzw. wird von Google nicht eindeutig kommuniziert.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie lange und wo werden die Daten gespeichert?
          </h3>
          <p>
            Anfragen für CSS-Assets speichert Google einen Tag lang auf seinen
            Servern, die hauptsächlich außerhalb der EU angesiedelt sind. Das
            ermöglicht uns, mithilfe eines Google-Stylesheets die Schriftarten
            zu nutzen. Ein Stylesheet ist eine Formatvorlage, über die man
            einfach und schnell z.B. das Design bzw. die Schriftart einer
            Webseite ändern kann.
          </p>
          <p>
            Die Font-Dateien werden bei Google ein Jahr gespeichert. Google
            verfolgt damit das Ziel, die Ladezeit von Webseiten grundsätzlich zu
            verbessern. Wenn Millionen von Webseiten auf die gleichen Schriften
            verweisen, werden sie nach dem ersten Besuch zwischengespeichert und
            erscheinen sofort auf allen anderen später besuchten Webseiten
            wieder. Manchmal aktualisiert Google Schriftdateien, um die
            Dateigröße zu reduzieren, die Abdeckung von Sprache zu erhöhen und
            das Design zu verbessern.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung
            verhindern?
          </h3>
          <p>
            Jene Daten, die Google für einen Tag bzw. ein Jahr speichert können
            nicht einfach gelöscht werden. Die Daten werden beim Seitenaufruf
            automatisch an Google übermittelt. Um diese Daten vorzeitig löschen
            zu können, müssen Sie den Google-Support auf{" "}
            <a
              className="adsimple-111742326"
              href="https://support.google.com/?hl=de&tid=111742326"
            >
              https://support.google.com/?hl=de&tid=111742326
            </a>{" "}
            kontaktieren. Datenspeicherung verhindern Sie in diesem Fall nur,
            wenn Sie unsere Seite nicht besuchen.
          </p>
          <p>
            Anders als andere Web-Schriften erlaubt uns Google uneingeschränkten
            Zugriff auf alle Schriftarten. Wir können also unlimitiert auf ein
            Meer an Schriftarten zugreifen und so das Optimum für unsere
            Webseite rausholen. Mehr zu Google Fonts und weiteren Fragen finden
            Sie auf{" "}
            <a
              className="adsimple-111742326"
              href="https://developers.google.com/fonts/faq?tid=111742326"
            >
              https://developers.google.com/fonts/faq?tid=111742326
            </a>
            . Dort geht zwar Google auf datenschutzrelevante Angelegenheiten
            ein, doch wirklich detaillierte Informationen über Datenspeicherung
            sind nicht enthalten. Es ist relativ schwierig, von Google wirklich
            präzise Informationen über gespeicherten Daten zu bekommen.
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Wenn Sie eingewilligt haben, dass Google Fonts eingesetzt werden
            darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung
            diese Einwilligung. Diese Einwilligung stellt laut
            <strong className="adsimple-111742326">
              {" "}
              Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
            </strong>{" "}
            die Rechtsgrundlage für die Verarbeitung personenbezogener Daten,
            wie sie bei der Erfassung durch Google Fonts vorkommen kann, dar.
          </p>
          <p>
            Von unserer Seite besteht zudem ein berechtigtes Interesse, Google
            Font zu verwenden, um unser Online-Service zu optimieren. Die dafür
            entsprechende Rechtsgrundlage ist{" "}
            <strong className="adsimple-111742326">
              Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
            </strong>
            .
          </p>
          <p>
            Welche Daten grundsätzlich von Google erfasst werden und wofür diese
            Daten verwendet werden, können Sie auch auf{" "}
            <a
              className="adsimple-111742326"
              href="https://policies.google.com/privacy?hl=de&tid=111742326"
            >
              https://www.google.com/intl/de/policies/privacy/
            </a>{" "}
            nachlesen.
          </p>
          <br /><h2
            id="font-awesome-datenschutzerklaerung"
            className="adsimple-111742326"
          >
            Font Awesome Datenschutzerklärung
          </h2>
          <p>
            Wir verwenden auf unserer Website Font Awesome des amerikanischen
            Unternehmens Fonticons (307 S. Main St., Suite 202, Bentonville, AR
            72712, USA). Wenn Sie eine unserer Webseite aufrufen, wird die
            Web-Schriftart Font Awesome (im Speziellen Icons) über das Font
            Awesome Content Delivery Netzwerk (CDN) geladen. So werden die Texte
            bzw. Schriften und Icons auf jedem Endgerät passend angezeigt. In
            dieser Datenschutzerklärung gehen wir näher auf die Datenspeicherung
            und Datenverarbeitung durch diesen Service ein.
          </p>
          <br /><h3 className="adsimple-111742326">Was ist Font Awesome?</h3>
          <p>
            Icons spielen für Websites eine immer wichtigere Rolle. Font Awesome
            ist eine Web-Schriftart, die speziell für Webdesigner und
            Webentwickler entwickelt wurde. Mit Font Awesome können etwa Icons
            mit Hilfe der Stylesheet-Sprache CSS nach Belieben skaliert und
            gefärbt werden. Sie ersetzen so alte Bild-Icons. Font Awesome CDN
            ist der einfachste Weg die Icons oder Schriftarten auf Ihre Website
            zu laden. Dafür mussten wir nur eine kleine Code-Zeile in unsere
            Website einbinden.
          </p>
          <br /><h3 className="adsimple-111742326">
            Warum verwenden wir Font Awesome auf unserer Website?
          </h3>
          <p>
            Durch Font Awesome können Inhalte auf unserer Website besser
            aufbereitet werden. So können Sie sich auf unserer Website besser
            orientieren und die Inhalte leichter erfassen. Mit den Icons kann
            man sogar manchmal ganze Wörter ersetzen und Platz sparen. Da ist
            besonders praktisch, wenn wir Inhalte speziell für Smartphones
            optimieren.  Diese Icons werden statt als Bild als HMTL-Code
            eingefügt. Dadurch können wir die Icons mit CSS genauso bearbeiten,
            wie wir wollen. Gleichzeitig verbessern wir mit Font Awesome auch
            unsere Ladegeschwindigkeit, weil es sich nur um HTML-Elemente
            handelt und nicht um Icon-Bilder. All diese Vorteile helfen uns, die
            Website für Sie noch übersichtlicher, frischer und schneller zu
            machen.
          </p>
          <br /><h3 className="adsimple-111742326">
            Welche Daten werden von Font Awesome gespeichert?
          </h3>
          <p>
            Zum Laden von Icons und Symbolen wird das Font Awesome Content
            Delivery Network (CDN) verwendet. CDNs sind Netzwerke von Servern,
            die weltweit verteilt sind und es möglich machen, schnell Dateien
            aus der Nähe zu laden. So werden auch, sobald Sie eine unserer
            Seiten aufrufen, die entsprechenden Icons von Font Awesome
            bereitgestellt.
          </p>
          <p>
            Damit die Web-Schriftarten geladen werden können, muss Ihr Browser
            eine Verbindung zu den Servern des Unternehmens Fonticons, Inc.
            herstellen. Dabei wird Ihre IP-Adresse erkannt. Font Awesome sammelt
            auch Daten darüber, welche Icon-Dateien wann heruntergeladen werden.
            Weiters werden auch technische Daten wie etwa Ihre Browser-Version,
            Bildschirmauflösung oder der Zeitpunkt der ausgerufenen Seite
            übertragen.
          </p>
          <p>
            Aus folgenden Gründen werden diese Daten gesammelt und gespeichert:
          </p>
          <ul className="adsimple-111742326">
            <li className="adsimple-111742326">
              um Content Delivery Netzwerke zu optimieren
            </li>
            <li className="adsimple-111742326">
              um technische Fehler zu erkennen und zu beheben
            </li>
            <li className="adsimple-111742326">
              um CDNs vor Missbrauch und Angriffen zu schützen
            </li>
            <li className="adsimple-111742326">
              um Gebühren von Font Awesome Pro-Kunden berechnen zu können
            </li>
            <li className="adsimple-111742326">
              um die Beliebtheit von Icons zu erfahren
            </li>
            <li className="adsimple-111742326">
              um zu wissen, welchen Computer und welche Software Sie verwenden
            </li>
          </ul>
          <p>
            Falls Ihr Browser Web-Schriftarten nicht zulässt, wird automatisch
            eine Standardschrift Ihres PCs verwendet. Nach derzeitigem Stand
            unserer Erkenntnis werden keine Cookies gesetzt. Wir sind mit der
            Datenschutzabteilung von Font Awesome in Kontakt und geben Ihnen
            Bescheid, sobald wir näheres in Erfahrung bringen.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie lange und wo werden die Daten gespeichert?
          </h3>
          <p>
            Font Awesome speichert Daten über die Nutzung des Content Delivery
            Network auf Servern auch in den Vereinigten Staaten von Amerika. Die
            CDN-Server befinden sich allerdings weltweit und speichern
            Userdaten, wo Sie sich befinden. In identifizierbarer Form werden
            die Daten in der Regel nur wenige Wochen gespeichert. Aggregierte
            Statistiken über die Nutzung von den CDNs können auch länger
            gespeichert werden. Personenbezogene Daten sind hier nicht
            enthalten.
          </p>
          <br /><h3 className="adsimple-111742326">
            Wie kann ich meine Daten löschen bzw. die Datenspeicherung
            verhindern?
          </h3>
          <p>
            Font Awesome speichert nach aktuellem Stand unseres Wissens keine
            personenbezogenen Daten über die Content Delivery Netzwerke. Wenn
            Sie nicht wollen, dass Daten über die verwendeten Icons gespeichert
            werden, können Sie leider unsere Website nicht besuchen. Wenn Ihr
            Browser keine Web-Schriftarten erlaubt, werden auch keine Daten
            übertragen oder gespeichert. In diesem Fall wird einfach die
            Standard-Schrift Ihres Computers verwendet.
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Wenn Sie eingewilligt haben, dass Font Awesome eingesetzt werden
            darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung
            diese Einwilligung. Diese Einwilligung stellt laut
            <strong className="adsimple-111742326">
              {" "}
              Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
            </strong>{" "}
            die Rechtsgrundlage für die Verarbeitung personenbezogener Daten,
            wie sie bei der Erfassung durch Font Awesome vorkommen kann, dar.
          </p>
          <p>
            Von unserer Seite besteht zudem ein berechtigtes Interesse, Font
            Awesome zu verwenden, um unser Online-Service zu optimieren. Die
            dafür entsprechende Rechtsgrundlage ist{" "}
            <strong className="adsimple-111742326">
              Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
            </strong>
            .
          </p>
          <p>
            Wenn Sie mehr über Font Awesome und deren Umgang mit Daten erfahren
            wollen, empfehlen wir Ihnen die Datenschutzerklärung unter{" "}
            <a
              className="adsimple-111742326"
              href="https://fontawesome.com/privacy"
            >
              https://fontawesome.com/privacy
            </a>{" "}
            und die Hilfeseite unter{" "}
            <a
              className="adsimple-111742326"
              href="https://fontawesome.com/help?tid=111742326"
            >
              https://fontawesome.com/help
            </a>
            .
          </p>
          <br /><h2
            id="bootstrapcdn-datenschutzerklaerung"
            className="adsimple-111742326"
          >
            BootstrapCDN Datenschutzerklärung
          </h2>
          <p>
            Um Ihnen all unsere einzelnen Webseiten (Unterseiten unserer
            Website) auf allen Geräten schnell und sicher ausliefern zu können,
            nutzen wir das Content Delivery Network (CDN) BootstrapCDN des
            amerikanischen Software-Unternehmens StackPath, LLC 2012 McKinney
            Ave. Suite 1100, Dallas, TX 75201, USA.
          </p>
          <p>
            Ein Content Delivery Network (CDN) ist ein Netzwerk regional
            verteilter Server, die über das Internet miteinander verbunden sind.
            Durch dieses Netzwerk können Inhalte, speziell sehr große Dateien,
            auch bei großen Lastspitzen schnell ausgeliefert werden.
          </p>
          <p>
            BootstrapCDN funktioniert so, dass sogenannte
            JavaScript-Bibliotheken an Ihren Browser ausgeliefert werden. Lädt
            nun Ihr Browser eine Datei vom BootstrapCDN herunter, wird Ihre
            IP-Adresse während der Verbindung zum Bootstrap-CDN-Server an das
            Unternehmen StackPath übermittelt.
          </p>
          <p>
            StackPath erwähnt auch in der hauseigenen Datenschutzerklärung, dass
            das Unternehmen aggregierte und anonymisierte Daten von diversen
            Diensten (wie BootstrapCDN) für die Erweiterung der Sicherung und
            für andere StackPath-Dienste und Clients verwenden. All diese Daten
            können aber keine Person identifizieren.
          </p>
          <br /><h3 className="adsimple-111742326">Widerspruchsrecht</h3>
          <p>
            Sie haben immer das Recht auf Auskunft, Berichtigung und Löschung
            Ihrer personenbezogenen Daten. Bei Fragen können Sie auch jederzeit
            Verantwortliche von BootstrapCDN kontaktieren.
          </p>
          <p>
            Wenn Sie diese Datenübertragung unterbinden wollen, können Sie einen
            JavaScript-Blocker (siehe beispielsweise{" "}
            <a
              className="adsimple-111742326"
              href="https://noscript.net/"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://noscript.net/
            </a>
            ) installieren oder in Ihrem Browser die Ausführung von
            JavaScript-Codes deaktivieren. Bitte beachten Sie aber, dass dadurch
            die Website nicht mehr das gewohnte Service (wie etwa schnelle
            Ladegeschwindigkeit) bieten kann.
          </p>
          <br /><h3 className="adsimple-111742326">Rechtsgrundlage</h3>
          <p>
            Wenn Sie eingewilligt haben, dass BootstrapCDN eingesetzt werden
            darf, ist die Rechtsgrundlage der entsprechenden Datenverarbeitung
            diese Einwilligung. Diese Einwilligung stellt laut
            <strong className="adsimple-111742326">
              {" "}
              Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)
            </strong>{" "}
            die Rechtsgrundlage für die Verarbeitung personenbezogener Daten,
            wie sie bei der Erfassung durch BootstrapCDN vorkommen kann, dar.
          </p>
          <p>
            Von unserer Seite besteht zudem ein berechtigtes Interesse,
            BootstrapCDN zu verwenden, um unser Online-Service zu optimieren und
            sicherer zu machen. Die dafür entsprechende Rechtsgrundlage ist{" "}
            <strong className="adsimple-111742326">
              Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
            </strong>
            .
          </p>
          <p>
            Bitte beachten Sie, dass bei der Verwendung dieses Tools Daten von
            Ihnen auch außerhalb der EU gespeichert und verarbeitet werden
            können. Die meisten Drittstaaten (darunter auch die USA) gelten nach
            derzeitigem europäischen Datenschutzrecht als nicht sicher. Daten an
            unsichere Drittstaaten dürfen also nicht einfach übertragen, dort
            gespeichert und verarbeitet werden, sofern es keine passenden
            Garantien (wie etwa EU-Standardvertragsklauseln) zwischen uns und
            dem außereuropäischen Dienstleister gibt.
          </p>
          <p>
            Mehr Informationen zum Datenschutz bei StackPath bzw. BootstrapCDN
            finden Sie auf{" "}
            <a
              className="adsimple-111742326"
              href="https://www.bootstrapcdn.com/privacy-policy/?tid=111742326"
              target="_blank"
              rel="noreferrer noreferrer"
            >
              https://www.bootstrapcdn.com/privacy-policy/
            </a>
            .
          </p>
          Alle Texte sind urheberrechtlich geschützt.
          <p style={{ marginTop: "15px" }}>
            Quelle: Erstellt mit dem{" "}
            <a
              href="https://www.adsimple.at/datenschutz-generator/"
              title="Datenschutz Generator von AdSimple"
            >
              Datenschutz Generator
            </a>{" "}
            von AdSimple
          </p>
        </div>
      </div>
    );
  }
}

export default Datenschutz;
